window.FoxTheme = window.FoxTheme || {};
FoxTheme.config = {
  hasLocalStorage: false,
  mqlMobile: false,
  mqlTablet: false,
  mqlLaptop: false,
  mqlSmallDesktop: false,
  mediaQueryMobile: 'screen and (max-width: 767px)',
  mediaQueryTablet: 'screen and (max-width: 1023px)',
  mediaQueryLaptop: 'screen and (max-width: 1279px)',
  mediaQuerySmallDesktop: 'screen and (max-width: 1535px)',
  motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
  isRTL: document.documentElement.getAttribute('dir') === 'rtl',
};
console.log(
  '%c' + window.FoxTheme.settings.themeName + ' theme (v' + window.FoxTheme.settings.themeVersion + ') by Foxecom',
  'font-size: 14px; color: #FF5C00;'
);
(function () {
  // Detect browser has support local storage.
  try {
    const key = 'hyper:test';
    window.localStorage.setItem(key, 'test');
    window.localStorage.removeItem(key);
    FoxTheme.config.hasLocalStorage = true;
  } catch (err) {}

  FoxTheme.DOMready = function (callback) {
    document.readyState != 'loading' ? callback() : document.addEventListener('DOMContentLoaded', callback);
  };

  FoxTheme.a11y = {
    trapFocusHandlers: {},
    getFocusableElements: (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    },
    trapFocus: (container, elementToFocus = container) => {
      var elements = FoxTheme.a11y.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];

      FoxTheme.a11y.removeTrapFocus();

      FoxTheme.a11y.trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
      };

      FoxTheme.a11y.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
      };

      FoxTheme.a11y.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
      document.addEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);

      elementToFocus.focus();

      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    },
    removeTrapFocus: (elementToFocus = null) => {
      document.removeEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);
      document.removeEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
      document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);

      if (elementToFocus) elementToFocus.focus();
    },
  };

  FoxTheme.utils = {
    throttle: (callback) => {
      let requestId = null,
        lastArgs;
      const later = (context) => () => {
        requestId = null;
        callback.apply(context, lastArgs);
      };
      const throttled = (...args) => {
        lastArgs = args;
        if (requestId === null) {
          requestId = requestAnimationFrame(later(this));
        }
      };
      throttled.cancel = () => {
        cancelAnimationFrame(requestId);
        requestId = null;
      };
      return throttled;
    },
    setScrollbarWidth: () => {
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      scrollbarWidth > 0 && document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    },
    waitForEvent: (element, eventName) => {
      return new Promise((resolve) => {
        // Event handler that checks if the event target is the expected element
        const eventHandler = (event) => {
          if (event.target === element) {
            element.removeEventListener(eventName, eventHandler); // Clean up listener
            resolve(event); // Resolve the promise with the event
          }
        };

        // Attach the event handler to the element
        element.addEventListener(eventName, eventHandler);
      });
    },
    queryDomNodes: (selectors = {}, context = document) => {
      const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
        const findOne = typeof selector === 'string';
        const queryMethod = findOne ? 'querySelector' : 'querySelectorAll';
        const sl = findOne ? selector : selector[0];

        acc[name] = context && context[queryMethod](sl);
        if (!findOne && acc[name]) {
          acc[name] = [...acc[name]];
        }
        return acc;
      }, {});
      return domNodes;
    },
    addEventDelegate: ({ context = document.documentElement, event = 'click', selector, handler, capture = false }) => {
      const listener = function (e) {
        // loop parent nodes from the target to the delegation node
        for (let target = e.target; target && target !== this; target = target.parentNode) {
          if (target.matches(selector)) {
            handler.call(target, e, target);
            break;
          }
        }
      };
      context.addEventListener(event, listener, capture);
      return () => {
        context.removeEventListener(event, listener, capture);
      };
    },
    getSectionId: (element) => {
      if (element.hasAttribute('data-section-id')) {
        return element.dataset.sectionId;
      } else {
        if (!element.classList.contains('shopify-section')) {
          element = element.closest('.shopify-section');
        }
        return element.id.replace('shopify-section-', '');
      }
    },
    debounce: (fn, wait) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },
    fetchConfig: (type = 'json') => {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    },
    /**
     * Store key-value pair with expiration time in localStorage
     * Use storage instead of cookie to make it work properly on Safari IOS (in iframe).
     */
    setStorage(key, value, expiryInDays = null) {
      if (!FoxTheme.config.hasLocalStorage) return;

      const item = {
        value: value,
      };

      if (expiryInDays !== null) {
        const now = new Date();
        item.expiry = now.getTime() + expiryInDays * 86400000;
      }

      window.localStorage.setItem(key, JSON.stringify(item));
    },
    getStorage(key) {
      if (!FoxTheme.config.hasLocalStorage) return null;

      const itemStr = window.localStorage.getItem(key);
      // If the item doesn't exist, return null.
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      // Compare the expiry time of the item with the current time.
      if (item.expiry && new Date().getTime() > item.expiry) {
        // If the item has expired, remove it from storage and return null.
        window.localStorage.removeItem(key);
        return null;
      }
      return item.value;
    },
    postLink: (path, options) => {
      options = options || {};
      const method = options['method'] || 'post';
      const params = options['parameters'] || {};

      const form = document.createElement('form');
      form.setAttribute('method', method);
      form.setAttribute('action', path);

      for (const key in params) {
        for (const index in params[key]) {
          for (const key2 in params[key][index]) {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', `${key}[${index}][${key2}]`);
            hiddenField.setAttribute('value', params[key][index][key2]);
            form.appendChild(hiddenField);
          }
        }
      }
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    imageReady: (imageOrArray) => {
      if (!imageOrArray) {
        return Promise.resolve();
      }
      imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
      return Promise.all(
        imageOrArray.map((image) => {
          return new Promise((resolve) => {
            if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
              resolve();
            } else {
              image.onload = () => resolve();
            }
          });
        })
      );
    },
    displayedMedia: (media) => {
      return Array.from(media).find((item) => {
        const style = window.getComputedStyle(item);
        return style.display !== 'none';
      });
    },
  };

  FoxTheme.pubsub = {
    PUB_SUB_EVENTS: {
      cartUpdate: 'cart-update',
      quantityUpdate: 'quantity-update',
      quantityRules: 'quantity-rules',
      quantityBoundries: 'quantity-boundries',
      variantChange: 'variant-change',
      cartError: 'cart-error',
      facetUpdate: 'facet-update',
      optionValueSelectionChange: 'option-value-selection-change',
    },
    subscribers: {},
    subscribe: (eventName, callback) => {
      if (FoxTheme.pubsub.subscribers[eventName] === undefined) {
        FoxTheme.pubsub.subscribers[eventName] = [];
      }

      FoxTheme.pubsub.subscribers[eventName] = [...FoxTheme.pubsub.subscribers[eventName], callback];

      return function unsubscribe() {
        FoxTheme.pubsub.subscribers[eventName] = FoxTheme.pubsub.subscribers[eventName].filter((cb) => {
          return cb !== callback;
        });
      };
    },

    publish: (eventName, data) => {
      if (FoxTheme.pubsub.subscribers[eventName]) {
        FoxTheme.pubsub.subscribers[eventName].forEach((callback) => {
          callback(data);
        });
      }
    },
  };

  FoxTheme.focusVisiblePolyfill = function () {
    const navKeys = [
      'ARROWUP',
      'ARROWDOWN',
      'ARROWLEFT',
      'ARROWRIGHT',
      'TAB',
      'ENTER',
      'SPACE',
      'ESCAPE',
      'HOME',
      'END',
      'PAGEUP',
      'PAGEDOWN',
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });

    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });

    window.addEventListener(
      'focus',
      () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
      },
      true
    );
  };

  FoxTheme.Carousel = (function () {
    class Carousel {
      constructor(container, options, modules = null) {
        this.container = container;
        let defaultModules = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.A11y];
        if (modules) {
          defaultModules = defaultModules.concat(modules);
        }
        this.options = {
          modules: defaultModules,
          ...options,
        };
      }

      init() {
        this.slider = new FoxTheme.Swiper.Swiper(this.container, this.options);
      }
    }
    return Carousel;
  })();

  FoxTheme.delayUntilInteraction = (function () {
    class ScriptLoader {
      constructor(callback, delay = 5000) {
        this.loadScriptTimer = setTimeout(callback, delay);
        this.userInteractionEvents = [
          'mouseover',
          'mousemove',
          'keydown',
          'touchstart',
          'touchend',
          'touchmove',
          'wheel',
        ];

        this.onScriptLoader = this.triggerScriptLoader.bind(this, callback);
        this.userInteractionEvents.forEach((event) => {
          window.addEventListener(event, this.onScriptLoader, {
            passive: !0,
          });
        });
      }

      triggerScriptLoader(callback) {
        callback();
        clearTimeout(this.loadScriptTimer);
        this.userInteractionEvents.forEach((event) => {
          window.removeEventListener(event, this.onScriptLoader, {
            passive: !0,
          });
        });
      }
    }

    return ScriptLoader;
  })();

  FoxTheme.Currency = (function () {
    const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  new FoxTheme.delayUntilInteraction(() => {
    document.body.removeAttribute('data-initializing');
  });

  FoxTheme.DOMready(FoxTheme.utils.setScrollbarWidth);
  // window.addEventListener('resize', FoxTheme.utils.throttle(FoxTheme.utils.setScrollbarWidth));

  const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
  FoxTheme.config.mqlMobile = mql.matches;
  mql.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlMobile = true;
      document.dispatchEvent(new CustomEvent('matchMobile'));
    } else {
      FoxTheme.config.mqlMobile = false;
      document.dispatchEvent(new CustomEvent('unmatchMobile'));
    }
  };

  const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
  FoxTheme.config.mqlTablet = mqlTablet.matches;
  mqlTablet.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlTablet = true;
      document.dispatchEvent(new CustomEvent('matchTablet'));
    } else {
      FoxTheme.config.mqlTablet = false;
      document.dispatchEvent(new CustomEvent('unmatchTablet'));
    }
  };

  const mqlLaptop = window.matchMedia(FoxTheme.config.mediaQueryLaptop);
  FoxTheme.config.mqlLaptop = mqlLaptop.matches;
  mqlLaptop.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlLaptop = true;
      document.dispatchEvent(new CustomEvent('matchLaptop'));
    } else {
      FoxTheme.config.mqlLaptop = false;
      document.dispatchEvent(new CustomEvent('unmatchLaptop'));
    }
  };

  const mqlSmallDesktop = window.matchMedia(FoxTheme.config.mediaQuerySmallDesktop);
  FoxTheme.config.mqlSmallDesktop = mqlSmallDesktop.matches;
  mqlSmallDesktop.onchange = (event) => {
    if (event.matches) {
      FoxTheme.config.mqlSmallDesktop = true;
      document.dispatchEvent(new CustomEvent('matchSmallDesktop'));
    } else {
      FoxTheme.config.mqlSmallDesktop = false;
      document.dispatchEvent(new CustomEvent('unmatchSmallDesktop'));
    }
  };
  function createOverlay() {
    if (!document.getElementById("cookieOverlayBlocker")) {
      const overlay = document.createElement("div");
      overlay.id = "cookieOverlayBlocker";
      overlay.classList.add("no-empty");
      overlay.textContent = " ";
      Object.assign(overlay.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: "10000",
        pointerEvents: "auto",
        cursor: "not-allowed"
      });

      document.body.appendChild(overlay);
      document.body.style.overflow = "hidden";
    }
  }

  function removeOverlay() {
    const overlay = document.getElementById("cookieOverlayBlocker");
    if (overlay) {
      overlay.remove();
      document.body.style.overflow = "";
    }
  }

  function checkAndCreateOverlay() {
    const pandectesBanner = document.getElementById("pandectes-banner");
    if (pandectesBanner && !pandectesBanner.classList.contains("cc-invisible")) {
      // Cookie banner is visible (does not have cc-invisible class), create overlay
      createOverlay();
    }
  }

  // Check for cookie banner and create overlay if needed
  checkAndCreateOverlay();

  // Also observe for cookie banner to appear dynamically
  const bannerObserver = new MutationObserver(() => {
    checkAndCreateOverlay();
  });

  bannerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Listen for Pandectes cookie banner button clicks using multiple approaches
  
  // Approach 1: Event delegation with capture phase (fires before onclick handlers)
  document.addEventListener("click", function(event) {
    const target = event.target;
    
    console.log("Click detected on:", target.tagName, target.className, target.id); // Debug log
    
    // Check if the clicked element matches any of the exact button selectors
    if (target.matches("#pandectes-banner > div > div.cc-compliance.cc-highlight > button.cc-btn.cc-btn-decision.cc-deny") ||
        target.matches("#pandectes-banner > div > div.cc-compliance.cc-highlight > button.cc-btn.cc-btn-decision.cc-allow") ||
        target.matches("#pd-cp-preferences > div > div.pd-cp-ui-content > div.pd-cp-ui-header > div.pd-cp-ui-horizontal-buttons > button.pd-cp-ui-rejectAll.pd-cp-btn.pd-cp-btn__small") ||
        target.matches("#pd-cp-preferences > div > div.pd-cp-ui-content > div.pd-cp-ui-header > div.pd-cp-ui-horizontal-buttons > button.pd-cp-ui-acceptAll.pd-cp-btn.pd-cp-btn__small") ||
        target.matches("#pd-cp-preferences > div > div.pd-cp-ui-content > div.pd-cp-ui-footer > div.pd-cp-ui-col-6.pd-cp-ui-float-right > button")) {
      
      console.log("Cookie banner button matched, removing overlay"); // Debug log
      removeOverlay();
    }
  }, true); // Use capture phase
  
  // Approach 2: Also listen on bubble phase as backup
  document.addEventListener("click", function(event) {
    const target = event.target;
    
    // Check for specific classes as backup method
    if ((target.classList.contains("cc-btn") && target.classList.contains("cc-deny")) ||
        (target.classList.contains("cc-btn") && target.classList.contains("cc-allow")) ||
        target.classList.contains("pd-cp-ui-rejectAll") ||
        target.classList.contains("pd-cp-ui-acceptAll") ||
        (target.classList.contains("pd-cp-btn") && target.classList.contains("pd-cp-ui-save"))) {
      
      console.log("Cookie banner button matched via class check, removing overlay"); // Debug log
      removeOverlay();
    }
  }, false); // Use bubble phase
  
  // Approach 3: Direct button attachment with polling
  function attachDirectListeners() {
    const selectors = [
      "#pandectes-banner > div > div.cc-compliance.cc-highlight > button.cc-btn.cc-btn-decision.cc-deny",
      "#pandectes-banner > div > div.cc-compliance.cc-highlight > button.cc-btn.cc-btn-decision.cc-allow",
      "#pd-cp-preferences > div > div.pd-cp-ui-content > div.pd-cp-ui-header > div.pd-cp-ui-horizontal-buttons > button.pd-cp-ui-rejectAll.pd-cp-btn.pd-cp-btn__small",
      "#pd-cp-preferences > div > div.pd-cp-ui-content > div.pd-cp-ui-header > div.pd-cp-ui-horizontal-buttons > button.pd-cp-ui-acceptAll.pd-cp-btn.pd-cp-btn__small",
      "#pd-cp-preferences > div > div.pd-cp-ui-content > div.pd-cp-ui-footer > div.pd-cp-ui-col-6.pd-cp-ui-float-right > button"
    ];
    
    selectors.forEach(selector => {
      const button = document.querySelector(selector);
      if (button && !button.hasAttribute('data-overlay-listener')) {
        button.addEventListener("click", function() {
          console.log("Direct listener triggered for:", selector);
          setTimeout(removeOverlay, 10); // Small delay to ensure it runs after onclick
        });
        button.setAttribute('data-overlay-listener', 'true');
      }
    });
  }
  
  // Try to attach direct listeners immediately and periodically
  attachDirectListeners();
  setInterval(attachDirectListeners, 1000); // Check every second for new buttons

  window.addEventListener("load", function() {
      // Türkiye şehir-ilçe listesi
      /* const districtsByCity = {
          "Adana": ["Aladağ", "Ceyhan", "Çukurova", "Feke", "İmamoğlu", "Karaisalı", "Karataş", "Kozan", "Pozantı", "Saimbeyli", "Sarıçam", "Seyhan", "Tufanbeyli", "Yumurtalık", "Yüreğir"],
          "Adıyaman": ["Besni", "Çelikhan", "Gerger", "Gölbaşı", "Kahta", "Merkez", "Samsat", "Sincik", "Tut"],
          "Afyonkarahisar": ["Başmakçı", "Bayat", "Bolvadin", "Çay", "Çobanlar", "Dazkırı", "Dinar", "Emirdağ", "Evciler", "Hocalar", "İhsaniye", "İscehisar", "Kızılören", "Merkez", "Sandıklı", "Sinanpaşa", "Sultandağı", "Şuhut"],
          "Ağrı": ["Diyadin", "Doğubayazıt", "Eleşkirt", "Hamur", "Merkez", "Patnos", "Taşlıçay", "Tutak"],
          "Amasya": ["Göynücek", "Gümüşhacıköy", "Hamamözü", "Merkez", "Merzifon", "Suluova", "Taşova"],
          "Ankara": ["Akyurt", "Altındağ", "Ayaş", "Bala", "Beypazarı", "Çamlıdere", "Çankaya", "Çubuk", "Elmadağ", "Etimesgut", "Evren", "Gölbaşı", "Güdül", "Haymana", "Kahramankazan", "Kalecik", "Keçiören", "Kızılcahamam", "Mamak", "Nallıhan", "Polatlı", "Pursaklar", "Sincan", "Şereflikoçhisar", "Yenimahalle"],
          "Antalya": ["Akseki", "Aksu", "Alanya", "Demre", "Döşemealtı", "Elmalı", "Finike", "Gazipaşa", "Gündoğmuş", "İbradı", "Kaş", "Kemer", "Kepez", "Konyaaltı", "Korkuteli", "Kumluca", "Manavgat", "Muratpaşa", "Serik"],
          "Artvin": ["Ardanuç", "Arhavi", "Borçka", "Hopa", "Kemalpaşa", "Murgul", "Şavşat", "Yusufeli", "Merkez"],
          "Aydın": ["Bozdoğan", "Buharkent", "Çine", "Didim", "Efeler", "Germencik", "İncirliova", "Karacasu", "Karpuzlu", "Koçarlı", "Köşk", "Kuşadası", "Kuyucak", "Nazilli", "Söke", "Sultanhisar", "Yenipazar"],
          "Balıkesir": ["Altıeylül", "Ayvalık", "Balya", "Bandırma", "Bigadiç", "Burhaniye", "Dursunbey", "Edremit", "Erdek", "Gömeç", "Gönen", "Havran", "İvrindi", "Karesi", "Kepsut", "Manyas", "Marmara", "Savaştepe", "Sındırgı", "Susurluk"],
          "Bilecik": ["Bozüyük", "Gölpazarı", "İnhisar", "Merkez", "Osmaneli", "Pazaryeri", "Söğüt", "Yenipazar"],
          "Bingöl": ["Adaklı", "Genç", "Karlıova", "Kiğı", "Merkez", "Solhan", "Yayladere", "Yedisu"],
          "Bitlis": ["Adilcevaz", "Ahlat", "Güroymak", "Hizan", "Merkez", "Mutki", "Tatvan"],
          "Bolu": ["Dörtdivan", "Gerede", "Göynük", "Kıbrıscık", "Mengen", "Merkez", "Mudurnu", "Seben", "Yeniçağa"],
          "Burdur": ["Ağlasun", "Altınyayla", "Bucak", "Çavdır", "Çeltikçi", "Gölhisar", "Karamanlı", "Kemer", "Merkez", "Tefenni", "Yeşilova"],
          "Bursa": ["Büyükorhan", "Gemlik", "Gürsu", "Harmancık", "İnegöl", "İznik", "Karacabey", "Keles", "Kestel", "Mudanya", "Mustafakemalpaşa", "Nilüfer", "Orhaneli", "Orhangazi", "Osmangazi", "Yenişehir", "Yıldırım"],
          "Çanakkale": ["Ayvacık", "Bayramiç", "Biga", "Bozcaada", "Çan", "Eceabat", "Ezine", "Gelibolu", "Gökçeada", "Lapseki", "Merkez", "Yenice"],
          "Çankırı": ["Atkaracalar", "Bayramören", "Çerkeş", "Eldivan", "Ilgaz", "Kızılırmak", "Korgun", "Kurşunlu", "Merkez", "Orta", "Şabanözü", "Yapraklı"],
          "Çorum": ["Alaca", "Bayat", "Boğazkale", "Dodurga", "İskilip", "Kargı", "Laçin", "Mecitözü", "Merkez", "Oğuzlar", "Ortaköy", "Osmancık", "Sungurlu", "Uğurludağ"],
          "Denizli": ["Acıpayam", "Babadağ", "Baklan", "Bekilli", "Beyağaç", "Bozkurt", "Buldan", "Çal", "Çameli", "Çardak", "Çivril", "Güney", "Honaz", "Kale", "Merkezefendi", "Pamukkale", "Sarayköy", "Serinhisar", "Tavas"],
          "Diyarbakır": ["Bağlar", "Bismil", "Çermik", "Çınar", "Çüngüş", "Dicle", "Eğil", "Ergani", "Hani", "Hazro", "Kayapınar", "Kocaköy", "Kulp", "Lice", "Silvan", "Sur", "Yenişehir"],
          "Edirne": ["Enez", "Havsa", "İpsala", "Keşan", "Lalapaşa", "Meriç", "Merkez", "Süloğlu", "Uzunköprü"],
          "Elazığ": ["Ağın", "Alacakaya", "Arıcak", "Baskil", "Karakoçan", "Keban", "Kovancılar", "Maden", "Merkez", "Palu", "Sivrice"],
          "Erzincan": ["Çayırlı", "İliç", "Kemah", "Kemaliye", "Merkez", "Otlukbeli", "Refahiye", "Tercan", "Üzümlü"],
          "Erzurum": ["Aşkale", "Aziziye", "Çat", "Hınıs", "Horasan", "İspir", "Karaçoban", "Karayazı", "Köprüköy", "Narman", "Oltu", "Olur", "Palandöken", "Pasinler", "Pazaryolu", "Şenkaya", "Tekman", "Tortum", "Uzundere", "Yakutiye"],
          "Eskişehir": ["Alpu", "Beylikova", "Çifteler", "Günyüzü", "Han", "İnönü", "Mahmudiye", "Mihalgazi", "Mihalıççık", "Odunpazarı", "Sarıcakaya", "Seyitgazi", "Sivrihisar", "Tepebaşı"],
          "Gaziantep": ["Araban", "İslahiye", "Karkamış", "Nizip", "Nurdağı", "Oğuzeli", "Şahinbey", "Şehitkamil", "Yavuzeli"],
          "Giresun": ["Alucra", "Bulancak", "Çamoluk", "Çanakçı", "Dereli", "Doğankent", "Espiye", "Eynesil", "Görele", "Güce", "Keşap", "Merkez", "Piraziz", "Şebinkarahisar", "Tirebolu", "Yağlıdere"],
          "Gümüşhane": ["Kelkit", "Köse", "Kürtün", "Merkez", "Şiran", "Torul"],
          "Hakkari": ["Çukurca", "Derecik", "Merkez", "Şemdinli", "Yüksekova"],
          "Hatay": ["Altınözü", "Antakya", "Arsuz", "Belen", "Defne", "Dörtyol", "Erzin", "Hassa", "İskenderun", "Kırıkhan", "Kumlu", "Payas", "Reyhanlı", "Samandağ", "Yayladağı"],
          "Isparta": ["Aksu", "Atabey", "Eğirdir", "Gelendost", "Gönen", "Keçiborlu", "Merkez", "Senirkent", "Sütçüler", "Şarkikaraağaç", "Uluborlu", "Yalvaç", "Yenişarbademli"],
          "Mersin": ["Akdeniz", "Anamur", "Aydıncık", "Bozyazı", "Çamlıyayla", "Erdemli", "Gülnar", "Mezitli", "Mut", "Silifke", "Tarsus", "Toroslar", "Yenişehir"],
          "İstanbul": ["Adalar", "Arnavutköy", "Ataşehir", "Avcılar", "Bağcılar", "Bahçelievler", "Bakırköy", "Başakşehir", "Bayrampaşa", "Beşiktaş", "Beykoz", "Beylikdüzü", "Beyoğlu", "Büyükçekmece", "Çatalca", "Çekmeköy", "Esenler", "Esenyurt", "Eyüpsultan", "Fatih", "Gaziosmanpaşa", "Güngören", "Kadıköy", "Kağıthane", "Kartal", "Küçükçekmece", "Maltepe", "Pendik", "Sancaktepe", "Sarıyer", "Silivri", "Sultanbeyli", "Sultangazi", "Şile", "Şişli", "Tuzla", "Ümraniye", "Üsküdar", "Zeytinburnu"],
          "İzmir": ["Aliağa", "Balçova", "Bayındır", "Bayraklı", "Bergama", "Beydağ", "Bornova", "Buca", "Çeşme", "Çiğli", "Dikili", "Foça", "Gaziemir", "Güzelbahçe", "Karabağlar", "Karaburun", "Karşıyaka", "Kemalpaşa", "Kınık", "Kiraz", "Konak", "Menderes", "Menemen", "Narlıdere", "Ödemiş", "Seferihisar", "Selçuk", "Tire", "Torbalı", "Urla"],
          "Kars": ["Akyaka", "Arpaçay", "Digor", "Kağızman", "Merkez", "Sarıkamış", "Selim", "Susuz"],
          "Kastamonu": ["Abana", "Ağlı", "Araç", "Azdavay", "Bozkurt", "Cide", "Çatalzeytin", "Daday", "Devrekani", "Doğanyurt", "Hanönü", "İhsangazi", "İnebolu", "Küre", "Merkez", "Pınarbaşı", "Seydiler", "Şenpazar", "Taşköprü", "Tosya"],
          "Kayseri": ["Akkışla", "Bünyan", "Develi", "Felahiye", "Hacılar", "İncesu", "Kocasinan", "Melikgazi", "Özvatan", "Pınarbaşı", "Sarıoğlan", "Sarız", "Talas", "Tomarza", "Yahyalı", "Yeşilhisar"],
          "Kırıkkale": ["Bahşili", "Balışeyh", "Çelebi", "Delice", "Karakeçili", "Keskin", "Merkez", "Sulakyurt", "Yahşihan"],
          "Kırklareli": ["Babaeski", "Demirköy", "Kofçaz", "Lüleburgaz", "Merkez", "Pehlivanköy", "Pınarhisar", "Vize"],
          "Kırşehir": ["Akçakent", "Akpınar", "Boztepe", "Çiçekdağı", "Kaman", "Merkez", "Mucur"],
          "Kocaeli": ["Başiskele", "Çayırova", "Darıca", "Derince", "Dilovası", "Gebze", "Gölcük", "İzmit", "Kandıra", "Karamürsel", "Kartepe", "Körfez"],
          "Konya": ["Ahırlı", "Akören", "Akşehir", "Altınekin", "Beyşehir", "Bozkır", "Cihanbeyli", "Çeltik", "Çumra", "Derbent", "Derebucak", "Doğanhisar", "Emirgazi", "Ereğli", "Güneysınır", "Hadim", "Halkapınar", "Hüyük", "Ilgın", "Kadınhanı", "Karapınar", "Karatay", "Kulu", "Meram", "Sarayönü", "Selçuklu", "Seydişehir", "Taşkent", "Tuzlukçu", "Yalıhüyük"],
          "Kütahya": ["Altıntaş", "Aslanapa", "Çavdarhisar", "Domaniç", "Dumlupınar", "Emet", "Gediz", "Hisarcık", "Merkez", "Pazarlar", "Simav", "Şaphane", "Tavşanlı"],
          "Malatya": ["Akçadağ", "Arapgir", "Arguvan", "Battalgazi", "Darende", "Doğanşehir", "Doğanyol", "Hekimhan", "Kale", "Kuluncak", "Pütürge", "Yazıhan", "Yeşilyurt"],
          "Manisa": ["Ahmetli", "Akhisar", "Alaşehir", "Demirci", "Gölmarmara", "Gördes", "Kırkağaç", "Köprübaşı", "Kula", "Salihli", "Sarıgöl", "Saruhanlı", "Selendi", "Soma", "Şehzadeler", "Turgutlu", "Yunusemre"],
          "Kahramanmaraş": ["Afşin", "Andırın", "Çağlayancerit", "Dulkadiroğlu", "Ekinözü", "Elbistan", "Göksun", "Nurhak", "Onikişubat", "Pazarcık", "Türkoğlu"],
          "Mardin": ["Artuklu", "Dargeçit", "Derik", "Kızıltepe", "Mazıdağı", "Midyat", "Nusaybin", "Ömerli", "Savur", "Yeşilli"],
          "Muğla": ["Bodrum", "Dalaman", "Datça", "Fethiye", "Kavaklıdere", "Köyceğiz", "Marmaris", "Menteşe", "Milas", "Ortaca", "Seydikemer", "Ula", "Yatağan"],
          "Muş": ["Bulanık", "Hasköy", "Korkut", "Malazgirt", "Merkez", "Varto"],
          "Nevşehir": ["Acıgöl", "Avanos", "Derinkuyu", "Gülşehir", "Hacıbektaş", "Kozaklı", "Merkez", "Ürgüp"],
          "Niğde": ["Altunhisar", "Bor", "Çamardı", "Çiftlik", "Merkez", "Ulukışla"],
          "Ordu": ["Akkuş", "Altınordu", "Aybastı", "Çamaş", "Çatalpınar", "Çaybaşı", "Fatsa", "Gölköy", "Gülyalı", "Gürgentepe", "İkizce", "Kabadüz", "Kabataş", "Korgan", "Kumru", "Mesudiye", "Perşembe", "Ulubey", "Ünye"],
          "Rize": ["Ardeşen", "Çamlıhemşin", "Çayeli", "Derepazarı", "Fındıklı", "Güneysu", "Hemşin", "İkizdere", "İyidere", "Kalkandere", "Merkez", "Pazar"],
          "Sakarya": ["Akyazı", "Arifiye", "Erenler", "Ferizli", "Geyve", "Hendek", "Karapürçek", "Karasu", "Kaynarca", "Kocaali", "Pamukova", "Sapanca", "Serdivan", "Söğütlü", "Taraklı", "Adapazarı"],
          "Samsun": ["Alaçam", "Asarcık", "Atakum", "Ayvacık", "Bafra", "Canik", "Çarşamba", "Havza", "İlkadım", "Kavak", "Ladik", "Salıpazarı", "Tekkeköy", "Terme", "Vezirköprü", "Yakakent", "19 Mayıs"],
          "Siirt": ["Baykan", "Eruh", "Kurtalan", "Merkez", "Pervari", "Şirvan", "Tillo"],
          "Sinop": ["Ayancık", "Boyabat", "Dikmen", "Durağan", "Erfelek", "Gerze", "Merkez", "Saraydüzü", "Türkeli"],
          "Sivas": ["Akıncılar", "Altınyayla", "Divriği", "Doğanşar", "Gemerek", "Gölova", "Gürün", "Hafik", "İmranlı", "Kangal", "Koyulhisar", "Merkez", "Suşehri", "Şarkışla", "Ulaş", "Yıldızeli", "Zara"],
          "Tekirdağ": ["Çerkezköy", "Çorlu", "Ergene", "Hayrabolu", "Kapaklı", "Malkara", "Marmaraereğlisi", "Muratlı", "Saray", "Süleymanpaşa", "Şarköy"],
          "Tokat": ["Almus", "Artova", "Başçiftlik", "Erbaa", "Merkez", "Niksar", "Pazar", "Reşadiye", "Sulusaray", "Turhal", "Yeşilyurt", "Zile"],
          "Trabzon": ["Akçaabat", "Araklı", "Arsin", "Beşikdüzü", "Çarşıbaşı", "Çaykara", "Dernekpazarı", "Düzköy", "Hayrat", "Köprübaşı", "Maçka", "Of", "Ortahisar", "Sürmene", "Şalpazarı", "Tonya", "Vakfıkebir", "Yomra"],
          "Tunceli": ["Çemişgezek", "Hozat", "Mazgirt", "Merkez", "Nazımiye", "Ovacık", "Pertek", "Pülümür"],
          "Şanlıurfa": ["Akçakale", "Birecik", "Bozova", "Ceylanpınar", "Eyyübiye", "Halfeti", "Haliliye", "Harran", "Hilvan", "Karaköprü", "Siverek", "Suruç", "Viranşehir"],
          "Uşak": ["Banaz", "Eşme", "Karahallı", "Merkez", "Sivaslı", "Ulubey"],
          "Van": ["Bahçesaray", "Başkale", "Çaldıran", "Çatak", "Edremit", "Erciş", "Gevaş", "Gürpınar", "İpekyolu", "Muradiye", "Özalp", "Saray", "Tuşba"],
          "Yozgat": ["Akdağmadeni", "Aydıncık", "Boğazlıyan", "Çandır", "Çayıralan", "Çekerek", "Kadışehri", "Merkez", "Saraykent", "Sarıkaya", "Sorgun", "Şefaatli", "Yenifakılı", "Yerköy"],
          "Zonguldak": ["Alaplı", "Çaycuma", "Devrek", "Ereğli", "Gökçebey", "Kilimli", "Kozlu", "Merkez"],
          "Aksaray": ["Ağaçören", "Eskil", "Gülağaç", "Güzelyurt", "Merkez", "Ortaköy", "Sarıyahşi", "Sultanhanı"],
          "Bayburt": ["Aydıntepe", "Demirözü", "Merkez"],
          "Karaman": ["Ayrancı", "Başyayla", "Ermenek", "Kazımkarabekir", "Merkez", "Sarıveliler"],
          "Kırıkkale": ["Bahşili", "Balışeyh", "Çelebi", "Delice", "Karakeçili", "Keskin", "Merkez", "Sulakyurt", "Yahşihan"],
          "Batman": ["Beşiri", "Gercüş", "Hasankeyf", "Kozluk", "Merkez", "Sason"],
          "Şırnak": ["Beytüşşebap", "Cizre", "Güçlükonak", "İdil", "Merkez", "Silopi", "Uludere"],
          "Bartın": ["Amasra", "Kurucaşile", "Merkez", "Ulus"],
          "Ardahan": ["Çıldır", "Damal", "Göle", "Hanak", "Merkez", "Posof"],
          "Iğdır": ["Aralık", "Karakoyunlu", "Merkez", "Tuzluca"],
          "Yalova": ["Altınova", "Armutlu", "Çiftlikköy", "Çınarcık", "Merkez", "Termal"],
          "Karabük": ["Eflani", "Eskipazar", "Merkez", "Ovacık", "Safranbolu", "Yenice"],
          "Kilis": ["Elbeyli", "Musabeyli", "Merkez", "Polateli"],
          "Osmaniye": ["Bahçe", "Düziçi", "Hasanbeyli", "Kadirli", "Merkez", "Sumbas", "Toprakkale"],
          "Düzce": ["Akçakoca", "Cumayeri", "Çilimli", "Gölyaka", "Gümüşova", "Kaynaşlı", "Merkez", "Yığılca"]
      }; */

      const taxOfficesByDistrict = {
          "Adana": [
              "Adana İhtisas Vergi Dairesi Müdürlüğü",
              "Ocak Vergi Dairesi Müdürlüğü",
              "Yüreğir Vergi Dairesi Müdürlüğü",
              "Seyhan Vergi Dairesi Müdürlüğü",
              "Ziyapaşa Vergi Dairesi Müdürlüğü",
              "Çukurova Vergi Dairesi Müdürlüğü",
              "Ceyhan Vergi Dairesi Müdürlüğü",
              "Kozan Vergi Dairesi Müdürlüğü",
              "Karataş Vergi Dairesi Müdürlüğü",
              "Pozantı Vergi Dairesi Müdürlüğü",
              "İmamoğlu Vergi Dairesi Müdürlüğü",
              "Karaisalı Vergi Dairesi Müdürlüğü",
              "Yumurtalık Vergi Dairesi Müdürlüğü",
              "Tufanbeyli Vergi Dairesi Müdürlüğü",
              "Feke Malmüdürlüğü",
              "Saimbeyli Malmüdürlüğü",
              "Aladağ Malmüdürlüğü"
          ],
          "Adıyaman": [
              "Adıyaman Vergi Dairesi Müdürlüğü",
              "Kahta Vergi Dairesi Müdürlüğü",
              "Besni Vergi Dairesi Müdürlüğü",
              "Gölbaşı Vergi Dairesi Müdürlüğü",
              "Çelikhan Malmüdürlüğü",
              "Gerger Malmüdürlüğü",
              "Samsat Malmüdürlüğü",
              "Sincik Malmüdürlüğü",
              "Tut Malmüdürlüğü"
          ],
          "Afyonkarahisar": [
              "Tınaztepe Vergi Dairesi Müdürlüğü",
              "Kocatepe Vergi Dairesi Müdürlüğü",
              "Dinar Vergi Dairesi Müdürlüğü",
              "Bolvadin Vergi Dairesi Müdürlüğü",
              "Emirdağ Vergi Dairesi Müdürlüğü",
              "Sandıklı Vergi Dairesi Müdürlüğü",
              "İscehisar Vergi Dairesi Müdürlüğü",
              "Çay Vergi Dairesi Müdürlüğü",
              "Sinanpaşa Vergi Dairesi Müdürlüğü",
              "Şuhut Vergi Dairesi Müdürlüğü",
              "İhsaniye Vergi Dairesi Müdürlüğü",
              "Sultandağı Vergi Dairesi Müdürlüğü",
              "Çobanlar Vergi Dairesi Müdürlüğü",
              "Dazkırı Vergi Dairesi Müdürlüğü",
              "Başmakçı Malmüdürlüğü",
              "Bayat Malmüdürlüğü",
              "Evciler Malmüdürlüğü",
              "Hocalar Malmüdürlüğü",
              "Kızılören Malmüdürlüğü"
          ],
          "Ağrı": [
              "Ağrı Vergi Dairesi Müdürlüğü",
              "Doğubeyazıt Vergi Dairesi Müdürlüğü",
              "Patnos Vergi Dairesi Müdürlüğü",
              "Diyadin Vergi Dairesi Müdürlüğü",
              "Eleşkirt Malmüdürlüğü",
              "Hamur Malmüdürlüğü",
              "Taşlıçay Malmüdürlüğü",
              "Tutak Malmüdürlüğü"
          ],
          "Amasya": [
              "Amasya Vergi Dairesi Müdürlüğü",
              "Merzifon Vergi Dairesi Müdürlüğü",
              "Gümüşhacıköy Vergi Dairesi Müdürlüğü",
              "Taşova Vergi Dairesi Müdürlüğü",
              "Suluova Vergi Dairesi Müdürlüğü",
              "Göynücek Malmüdürlüğü",
              "Hamamözü Malmüdürlüğü"
          ],
          "Ankara": [
              "Anadolu İhtisas Vergi Dairesi Müdürlüğü",
              "Ankara İhtisas Vergi Dairesi Müdürlüğü",
              "Harçlar Vergi Dairesi Müdürlüğü",
              "Ankara Kurumlar Vergi Dairesi Müdürlüğü",
              "İvedik Vergi Dairesi Müdürlüğü",
              "Veraset ve İntikal Vergi Dairesi Müdürlüğü",
              "Kavaklıdere Vergi Dairesi Müdürlüğü",
              "Maltepe Vergi Dairesi Müdürlüğü",
              "Yenimahalle Vergi Dairesi Müdürlüğü",
              "Çankaya Vergi Dairesi Müdürlüğü",
              "Kızılbey Vergi Dairesi Müdürlüğü",
              "Mithatpaşa Vergi Dairesi Müdürlüğü",
              "Ulus Vergi Dairesi Müdürlüğü",
              "Yıldırım Beyazıt Vergi Dairesi Müdürlüğü",
              "Seğmenler Vergi Dairesi Müdürlüğü",
              "Dikimevi Vergi Dairesi Müdürlüğü",
              "Doğanbey Vergi Dairesi Müdürlüğü",
              "Yeğenbey Vergi Dairesi Müdürlüğü",
              "Hitit Vergi Dairesi Müdürlüğü",
              "Yahya Galip Vergi Dairesi Müdürlüğü",
              "Muhammet Karagüzel Vergi Dairesi Müdürlüğü",
              "Ostim Vergi Dairesi Müdürlüğü",
              "Gölbaşı Vergi Dairesi Müdürlüğü",
              "Sincan Vergi Dairesi Müdürlüğü",
              "Dışkapı Vergi Dairesi Müdürlüğü",
              "Etimesgut Vergi Dairesi Müdürlüğü",
              "Başkent Vergi Dairesi Müdürlüğü",
              "Cumhuriyet Vergi Dairesi Müdürlüğü",
              "Keçiören Vergi Dairesi Müdürlüğü",
              "Kahramankazan Vergi Dairesi Müdürlüğü",
              "Polatlı Vergi Dairesi Müdürlüğü",
              "Şereflikoçhisar Vergi Dairesi Müdürlüğü",
              "Beypazarı Vergi Dairesi Müdürlüğü",
              "Çubuk Vergi Dairesi Müdürlüğü",
              "Haymana Vergi Dairesi Müdürlüğü",
              "Elmadağ Vergi Dairesi Müdürlüğü",
              "Akyurt Vergi Dairesi Müdürlüğü",
              "Kızılcahamam Vergi Dairesi Müdürlüğü",
              "Nallıhan Vergi Dairesi Müdürlüğü",
              "Ayaş Vergi Dairesi Müdürlüğü",
              "Çamlıdere Malmüdürlüğü",
              "Güdül Malmüdürlüğü",
              "Kalecik Malmüdürlüğü",
              "Evren Malmüdürlüğü"
          ],
          "Antalya": [
              "Üçkapılar Vergi Dairesi Müdürlüğü",
              "Kalekapı Vergi Dairesi Müdürlüğü",
              "Muratpaşa Vergi Dairesi Müdürlüğü",
              "Düden Vergi Dairesi Müdürlüğü",
              "Antalya Kurumlar Vergi Dairesi Müdürlüğü",
              "Antalya İhtisas Vergi Dairesi Müdürlüğü",
              "Korkuteli Vergi Dairesi Müdürlüğü",
              "Alanya Vergi Dairesi Müdürlüğü",
              "Serik Vergi Dairesi Müdürlüğü",
              "Manavgat Vergi Dairesi Müdürlüğü",
              "Elmalı Vergi Dairesi Müdürlüğü",
              "Kemer Vergi Dairesi Müdürlüğü",
              "Kumluca Vergi Dairesi Müdürlüğü",
              "Finike Vergi Dairesi Müdürlüğü",
              "Gazipaşa Vergi Dairesi Müdürlüğü",
              "Kaş Vergi Dairesi Müdürlüğü",
              "Demre Vergi Dairesi Müdürlüğü",
              "Akseki Malmüdürlüğü",
              "Gündoğmuş Malmüdürlüğü",
              "İbradı Malmüdürlüğü"
          ],
          "Artvin": [
              "Artvin Vergi Dairesi Müdürlüğü",
              "Hopa Vergi Dairesi Müdürlüğü",
              "Arhavi Vergi Dairesi Müdürlüğü",
              "Borçka Vergi Dairesi Müdürlüğü",
              "Yusufeli Vergi Dairesi Müdürlüğü",
              "Şavşat Vergi Dairesi Müdürlüğü",
              "Ardanuç Malmüdürlüğü",
              "Murgul Malmüdürlüğü"
          ],
          "Aydın": [
              "Efeler Vergi Dairesi Müdürlüğü",
              "Güzelhisar Vergi Dairesi Müdürlüğü",
              "Nazilli Vergi Dairesi Müdürlüğü",
              "Söke Vergi Dairesi Müdürlüğü",
              "Çine Vergi Dairesi Müdürlüğü",
              "Germencik Vergi Dairesi Müdürlüğü",
              "Kuşadası Vergi Dairesi Müdürlüğü",
              "Didim Vergi Dairesi Müdürlüğü",
              "İncirliova Vergi Dairesi Müdürlüğü",
              "Kuyucak Vergi Dairesi Müdürlüğü",
              "Bozdoğan Vergi Dairesi Müdürlüğü",
              "Sultanhisar Vergi Dairesi Müdürlüğü",
              "Karacasu Vergi Dairesi Müdürlüğü",
              "Koçarlı Vergi Dairesi Müdürlüğü",
              "Buharkent Vergi Dairesi Müdürlüğü",
              "Köşk Vergi Dairesi Müdürlüğü",
              "Yenipazar Vergi Dairesi Müdürlüğü",
              "Karpuzlu Malmüdürlüğü"
          ],
          "Balıkesir": [
              "Karesi Vergi Dairesi Müdürlüğü",
              "Kurtdereli Vergi Dairesi Müdürlüğü",
              "Ayvalık Vergi Dairesi Müdürlüğü",
              "Bandırma Vergi Dairesi Müdürlüğü",
              "Burhaniye Vergi Dairesi Müdürlüğü",
              "Edremit Vergi Dairesi Müdürlüğü",
              "Gönen Vergi Dairesi Müdürlüğü",
              "Susurluk Vergi Dairesi Müdürlüğü",
              "Erdek Vergi Dairesi Müdürlüğü",
              "Bigadiç Vergi Dairesi Müdürlüğü",
              "Sındırgı Vergi Dairesi Müdürlüğü",
              "Dursunbey Vergi Dairesi Müdürlüğü",
              "Gömeç Vergi Dairesi Müdürlüğü",
              "Havran Vergi Dairesi Müdürlüğü",
              "İvrindi Vergi Dairesi Müdürlüğü",
              "Manyas Vergi Dairesi Müdürlüğü",
              "Kepsut Vergi Dairesi Müdürlüğü",
              "Marmara Vergi Dairesi Müdürlüğü",
              "Savaştepe Vergi Dairesi Müdürlüğü",
              "Balya Malmüdürlüğü"
          ],
          "Bilecik": [
              "Bilecik Vergi Dairesi Müdürlüğü",
              "Bozüyük Vergi Dairesi Müdürlüğü",
              "Osmaneli Vergi Dairesi Müdürlüğü",
              "Söğüt Vergi Dairesi Müdürlüğü",
              "Gölpazarı Malmüdürlüğü",
              "Pazaryeri Malmüdürlüğü",
              "Yenipazar Malmüdürlüğü",
              "İnhisar Malmüdürlüğü"
          ],
          "Bingöl": [
              "Bingöl Vergi Dairesi Müdürlüğü",
              "Solhan Vergi Dairesi Müdürlüğü",
              "Genç Vergi Dairesi Müdürlüğü",
              "Karlıova Malmüdürlüğü",
              "Kiğı Malmüdürlüğü",
              "Adaklı Malmüdürlüğü",
              "Yayladere Malmüdürlüğü",
              "Yedisu Malmüdürlüğü"
          ],
          "Bitlis": [
              "Bitlis Vergi Dairesi Müdürlüğü",
              "Tatvan Vergi Dairesi Müdürlüğü",
              "Ahlat Vergi Dairesi Müdürlüğü",
              "Güroymak Vergi Dairesi Müdürlüğü",
              "Hizan Vergi Dairesi Müdürlüğü",
              "Adilcevaz Vergi Dairesi Müdürlüğü",
              "Mutki Malmüdürlüğü"
          ],
          "Bolu": [
              "Bolu Vergi Dairesi Müdürlüğü",
              "Gerede Vergi Dairesi Müdürlüğü",
              "Göynük Vergi Dairesi Müdürlüğü",
              "Mudurnu Vergi Dairesi Müdürlüğü",
              "Mengen Vergi Dairesi Müdürlüğü",
              "Kıbrıscık Malmüdürlüğü",
              "Seben Malmüdürlüğü",
              "Dörtdivan Malmüdürlüğü",
              "Yeniçağa Malmüdürlüğü"
          ],
          "Burdur": [
              "Burdur Vergi Dairesi Müdürlüğü",
              "Bucak Vergi Dairesi Müdürlüğü",
              "Gölhisar Vergi Dairesi Müdürlüğü",
              "Çavdır Vergi Dairesi Müdürlüğü",
              "Yeşilova Vergi Dairesi Müdürlüğü",
              "Tefenni Vergi Dairesi Müdürlüğü",
              "Ağlasun Malmüdürlüğü",
              "Karamanlı Malmüdürlüğü",
              "Kemer Malmüdürlüğü",
              "Altınyayla Malmüdürlüğü",
              "Çeltikçi Malmüdürlüğü"
          ],
          "Bursa": [
              "Bursa İhtisas Vergi Dairesi Müdürlüğü",
              "Osmangazi Vergi Dairesi Müdürlüğü",
              "Yıldırım Vergi Dairesi Müdürlüğü",
              "Çekirge Vergi Dairesi Müdürlüğü",
              "Setbaşı Vergi Dairesi Müdürlüğü",
              "Uludağ Vergi Dairesi Müdürlüğü",
              "Yeşil Vergi Dairesi Müdürlüğü",
              "Nilüfer Vergi Dairesi Müdürlüğü",
              "Ertuğrulgazi Vergi Dairesi Müdürlüğü",
              "Gökdere Vergi Dairesi Müdürlüğü",
              "Bursa Veraset ve Harçlar Vergi Dairesi Müdürlüğü",
              "Gemlik Vergi Dairesi Müdürlüğü",
              "İnegöl Vergi Dairesi Müdürlüğü",
              "Karacabey Vergi Dairesi Müdürlüğü",
              "Mustafakemalpaşa Vergi Dairesi Müdürlüğü",
              "Mudanya Vergi Dairesi Müdürlüğü",
              "Orhangazi Vergi Dairesi Müdürlüğü",
              "İznik Vergi Dairesi Müdürlüğü",
              "Yenişehir Vergi Dairesi Müdürlüğü",
              "Orhaneli Vergi Dairesi Müdürlüğü",
              "Keles Malmüdürlüğü",
              "Harmancık Malmüdürlüğü",
              "Büyükorhan Malmüdürlüğü"
          ],
          "Çanakkale": [
              "Çanakkale Vergi Dairesi Müdürlüğü",
              "Biga Vergi Dairesi Müdürlüğü",
              "Çan Vergi Dairesi Müdürlüğü",
              "Gelibolu Vergi Dairesi Müdürlüğü",
              "Ezine Vergi Dairesi Müdürlüğü",
              "Ayvacık Vergi Dairesi Müdürlüğü",
              "Lapseki Vergi Dairesi Müdürlüğü",
              "Gökçeada Vergi Dairesi Müdürlüğü",
              "Bayramiç Vergi Dairesi Müdürlüğü",
              "Yenice Vergi Dairesi Müdürlüğü",
              "Eceabat Vergi Dairesi Müdürlüğü",
              "Bozcaada Malmüdürlüğü"
          ],
          "Çankırı": [
              "Çankırı Vergi Dairesi Müdürlüğü",
              "Çerkeş Vergi Dairesi Müdürlüğü",
              "Ilgaz Vergi Dairesi Müdürlüğü",
              "Eldivan Malmüdürlüğü",
              "Kurşunlu Malmüdürlüğü",
              "Orta Malmüdürlüğü",
              "Şabanözü Malmüdürlüğü",
              "Yapraklı Malmüdürlüğü",
              "Atkaracalar Malmüdürlüğü",
              "Kızılırmak Malmüdürlüğü",
              "Bayramören Malmüdürlüğü",
              "Korgun Malmüdürlüğü"
          ],
          "Çorum": [
              "Çorum Vergi Dairesi Müdürlüğü",
              "Hasanpaşa Vergi Dairesi Müdürlüğü",
              "Sungurlu Vergi Dairesi Müdürlüğü",
              "Osmancık Vergi Dairesi Müdürlüğü",
              "İskilip Vergi Dairesi Müdürlüğü",
              "Alaca Vergi Dairesi Müdürlüğü",
              "Kargı Vergi Dairesi Müdürlüğü",
              "Mecitözü Vergi Dairesi Müdürlüğü",
              "Bayat Malmüdürlüğü",
              "Ortaköy Malmüdürlüğü",
              "Boğazkale Malmüdürlüğü",
              "Uğurludağ Malmüdürlüğü",
              "Dodurga Malmüdürlüğü",
              "Oğuzlar Malmüdürlüğü",
              "Laçin Malmüdürlüğü"
          ],
          "Denizli": [
              "Saraylar Vergi Dairesi Müdürlüğü",
              "Çınar Vergi Dairesi Müdürlüğü",
              "Gökpınar Vergi Dairesi Müdürlüğü",
              "Denizli İhtisas Vergi Dairesi Müdürlüğü",
              "Pamukkale Vergi Dairesi Müdürlüğü",
              "Sarayköy Vergi Dairesi Müdürlüğü",
              "Acıpayam Vergi Dairesi Müdürlüğü",
              "Tavas Vergi Dairesi Müdürlüğü",
              "Buldan Vergi Dairesi Müdürlüğü",
              "Çal Vergi Dairesi Müdürlüğü",
              "Çivril Vergi Dairesi Müdürlüğü",
              "Honaz Vergi Dairesi Müdürlüğü",
              "Kale Vergi Dairesi Müdürlüğü",
              "Serinhisar Vergi Dairesi Müdürlüğü",
              "Çameli Vergi Dairesi Müdürlüğü",
              "Babadağ Vergi Dairesi Müdürlüğü",
              "Bozkurt Vergi Dairesi Müdürlüğü",
              "Çardak Malmüdürlüğü",
              "Güney Malmüdürlüğü",
              "Bekilli Malmüdürlüğü",
              "Baklan Malmüdürlüğü",
              "Beyağaç Malmüdürlüğü"
          ],
          "Diyarbakır": [
              "Gökalp Vergi Dairesi Müdürlüğü",
              "Süleyman Nazif Vergi Dairesi Müdürlüğü",
              "Cahit Sıtkı Tarancı Vergi Dairesi Müdürlüğü",
              "Ergani Vergi Dairesi Müdürlüğü",
              "Bismil Vergi Dairesi Müdürlüğü",
              "Silvan Vergi Dairesi Müdürlüğü",
              "Çermik Vergi Dairesi Müdürlüğü",
              "Çınar Vergi Dairesi Müdürlüğü",
              "Çüngüş Malmüdürlüğü",
              "Dicle Malmüdürlüğü",
              "Hani Malmüdürlüğü",
              "Hazro Malmüdürlüğü",
              "Kulp Malmüdürlüğü",
              "Lice Malmüdürlüğü",
              "Eğil Malmüdürlüğü",
              "Kocaköy Malmüdürlüğü"
          ],
          "Edirne": [
              "Arda Vergi Dairesi Müdürlüğü",
              "Kırkpınar Vergi Dairesi Müdürlüğü",
              "Keşan Vergi Dairesi Müdürlüğü",
              "Uzunköprü Vergi Dairesi Müdürlüğü",
              "Havsa Vergi Dairesi Müdürlüğü",
              "İpsala Vergi Dairesi Müdürlüğü",
              "Enez Vergi Dairesi Müdürlüğü",
              "Meriç Vergi Dairesi Müdürlüğü",
              "Lalapaşa Malmüdürlüğü",
              "Süloğlu Malmüdürlüğü"
          ],
          "Elazığ": [
              "Harput Vergi Dairesi Müdürlüğü",
              "Hazar Vergi Dairesi Müdürlüğü",
              "Karakoçan Vergi Dairesi Müdürlüğü",
              "Kovancılar Vergi Dairesi Müdürlüğü",
              "Ağın Malmüdürlüğü",
              "Baskil Malmüdürlüğü",
              "Keban Malmüdürlüğü",
              "Maden Malmüdürlüğü",
              "Palu Malmüdürlüğü",
              "Sivrice Malmüdürlüğü",
              "Arıcak Malmüdürlüğü",
              "Alacakaya Malmüdürlüğü"
          ],
          "Erzincan": [
              "Fevzipaşa Vergi Dairesi Müdürlüğü",
              "Çayırlı Malmüdürlüğü",
              "İliç Malmüdürlüğü",
              "Kemah Malmüdürlüğü",
              "Kemaliye Malmüdürlüğü",
              "Refahiye Malmüdürlüğü",
              "Tercan Malmüdürlüğü",
              "Üzümlü Malmüdürlüğü",
              "Otlukbeli Malmüdürlüğü"
          ],
          "Erzurum": [
              "Aziziye Vergi Dairesi Müdürlüğü",
              "Kazımkarabekir Vergi Dairesi Müdürlüğü",
              "Horasan Vergi Dairesi Müdürlüğü",
              "Oltu Vergi Dairesi Müdürlüğü",
              "Pasinler Vergi Dairesi Müdürlüğü",
              "Aşkale Vergi Dairesi Müdürlüğü",
              "Çat Malmüdürlüğü",
              "Hınıs Malmüdürlüğü",
              "İspir Malmüdürlüğü",
              "Karayazı Malmüdürlüğü",
              "Narman Malmüdürlüğü",
              "Olur Malmüdürlüğü",
              "Şenkaya Malmüdürlüğü",
              "Tekman Malmüdürlüğü",
              "Tortum Malmüdürlüğü",
              "Karaçoban Malmüdürlüğü",
              "Uzundere Malmüdürlüğü",
              "Pazaryolu Malmüdürlüğü",
              "Aziziye Malmüdürlüğü",
              "Köprüköy Malmüdürlüğü"
          ],
          "Eskişehir": [
              "Mahmudiye Malmüdürlüğü",
              "Mihalıççık Malmüdürlüğü",
              "Sarıcakaya Malmüdürlüğü",
              "Seyitgazi Malmüdürlüğü",
              "Alpu Malmüdürlüğü",
              "Beylikova Malmüdürlüğü",
              "İnönü Malmüdürlüğü",
              "Günyüzü Malmüdürlüğü",
              "Han Malmüdürlüğü",
              "Mihalgazi Malmüdürlüğü"
          ],
          "Gaziantep": [
              "Gaziantep İhtisas Vergi Dairesi Müdürlüğü",
              "Suburcu Vergi Dairesi Müdürlüğü",
              "Şahinbey Vergi Dairesi Müdürlüğü",
              "Gazikent Vergi Dairesi Müdürlüğü",
              "Kozanlı Vergi Dairesi Müdürlüğü",
              "Nizip Vergi Dairesi Müdürlüğü",
              "İslahiye Vergi Dairesi Müdürlüğü",
              "Oğuzeli Vergi Dairesi Müdürlüğü",
              "Nurdağı Vergi Dairesi Müdürlüğü",
              "Araban Vergi Dairesi Müdürlüğü",
              "Yavuzeli Malmüdürlüğü",
              "Karkamış Malmüdürlüğü"
          ],
          "Giresun": [
              "Giresun Vergi Dairesi Müdürlüğü",
              "Bulancak Vergi Dairesi Müdürlüğü",
              "Tirebolu Vergi Dairesi Müdürlüğü",
              "Espiye Vergi Dairesi Müdürlüğü",
              "Görele Vergi Dairesi Müdürlüğü",
              "Dereli Vergi Dairesi Müdürlüğü",
              "Keşap Vergi Dairesi Müdürlüğü",
              "Şebinkarahisar Vergi Dairesi Müdürlüğü",
              "Eynesil Vergi Dairesi Müdürlüğü",
              "Alucra Malmüdürlüğü",
              "Piraziz Malmüdürlüğü",
              "Yağlıdere Malmüdürlüğü",
              "Çanakçı Malmüdürlüğü",
              "Güce Malmüdürlüğü",
              "Çamoluk Malmüdürlüğü",
              "Doğankent Malmüdürlüğü"
          ],
          "Gümüşhane": [
              "Gümüşhane Vergi Dairesi Müdürlüğü",
              "Kelkit Vergi Dairesi Müdürlüğü",
              "Şiran Malmüdürlüğü",
              "Torul Malmüdürlüğü",
              "Köse Malmüdürlüğü",
              "Kürtün Malmüdürlüğü"
          ],
          "Hakkari": [
              "Hakkari Vergi Dairesi Müdürlüğü",
              "Yüksekova Vergi Dairesi Müdürlüğü",
              "Şemdinli Vergi Dairesi Müdürlüğü",
              "Çukurca Malmüdürlüğü",
              "Derecik Malmüdürlüğü"
          ],
          "Hatay": [
              "Temmuz Vergi Dairesi Müdürlüğü",
              "Antakya Vergi Dairesi Müdürlüğü",
              "Şükrükanatlı Vergi Dairesi Müdürlüğü",
              "Sahil Vergi Dairesi Müdürlüğü",
              "Akdeniz Vergi Dairesi Müdürlüğü",
              "Asım Gündüz Vergi Dairesi Müdürlüğü",
              "Dörtyol  Vergi Dairesi Müdürlüğü",
              "Kırıkhan Vergi Dairesi Müdürlüğü",
              "Reyhanlı Vergi Dairesi Müdürlüğü",
              "Samandağ Vergi Dairesi Müdürlüğü",
              "Hassa Vergi Dairesi Müdürlüğü",
              "Erzin Vergi Dairesi Müdürlüğü",
              "Yayladağı Vergi Dairesi Müdürlüğü",
              "Altınözü Vergi Dairesi Müdürlüğü",
              "Belen Vergi Dairesi Müdürlüğü",
              "Kumlu Malmüdürlüğü"
          ],
          "Isparta": [
              "Davraz Vergi Dairesi Müdürlüğü",
              "Kaymakkapı Vergi Dairesi Müdürlüğü",
              "Eğirdir Vergi Dairesi Müdürlüğü",
              "Yalvaç Vergi Dairesi Müdürlüğü",
              "Şarkikaraağaç Vergi Dairesi Müdürlüğü",
              "Keçiborlu Vergi Dairesi Müdürlüğü",
              "Senirkent Vergi Dairesi Müdürlüğü",
              "Gelendost Vergi Dairesi Müdürlüğü",
              "Atabey Malmüdürlüğü",
              "Sütçüler Malmüdürlüğü",
              "Uluborlu Malmüdürlüğü",
              "Aksu Malmüdürlüğü",
              "Gönen Malmüdürlüğü",
              "Yenişarbademli Malmüdürlüğü"
          ],
          "Mersin": [
              "Uray Vergi Dairesi Müdürlüğü",
              "Liman Vergi Dairesi Müdürlüğü",
              "Toros Vergi Dairesi Müdürlüğü",
              "Mersin İhtisas Vergi Dairesi Müdürlüğü",
              "Erdemli Vergi Dairesi Müdürlüğü",
              "Silifke Vergi Dairesi Müdürlüğü",
              "Anamur Vergi Dairesi Müdürlüğü",
              "Kızılmurat Vergi Dairesi Müdürlüğü",
              "Şehitkerim Vergi Dairesi Müdürlüğü",
              "Mut Vergi Dairesi Müdürlüğü",
              "Bozyazı Vergi Dairesi Müdürlüğü",
              "Gülnar Vergi Dairesi Müdürlüğü",
              "Aydıncık Malmüdürlüğü",
              "Çamlıyayla Malmüdürlüğü"
          ],
          "İstanbul": [
              "Haliç İhtisas Vergi Dairesi Müdürlüğü",
              "Vatan İhtisas Vergi Dairesi Müdürlüğü",
              "Çamlıca İhtisas Vergi Dairesi Müdürlüğü",
              "Alemdağ Vergi Dairesi Müdürlüğü",
              "Yenikapı Vergi Dairesi Müdürlüğü",
              "Büyük Mükellefler Vergi Dairesi Müdürlüğü",
              "Boğaziçi Kurumlar Vergi Dairesi Müdürlüğü",
              "Marmara Kurumlar Vergi Dairesi Müdürlüğü",
              "Davutpaşa Vergi Dairesi Müdürlüğü",
              "Esenler Vergi Dairesi Müdürlüğü",
              "Fatih Vergi Dairesi Müdürlüğü",
              "Küçükköy Vergi Dairesi Müdürlüğü",
              "Merter Vergi Dairesi Müdürlüğü",
              "Sultanbeyli Vergi Dairesi Müdürlüğü",
              "Anadolu Kurumlar Vergi Dairesi Müdürlüğü",
              "Tuzla Vergi Dairesi Müdürlüğü",
              "Kozyatağı Vergi Dairesi Müdürlüğü",
              "Maslak Vergi Dairesi Müdürlüğü",
              "Zincirlikuyu Vergi Dairesi Müdürlüğü",
              "İkitelli Vergi Dairesi Müdürlüğü",
              "Beşiktaş Vergi Dairesi Müdürlüğü",
              "Ümraniye Vergi Dairesi Müdürlüğü",
              "Yeditepe Veraset ve Harçlar Vergi Dairesi Müdürlüğü",
              "Kasımpaşa Vergi Dairesi Müdürlüğü",
              "Erenköy Vergi Dairesi Müdürlüğü",
              "Hisar Veraset ve Harçlar Vergi Dairesi Müdürlüğü",
              "Tuna Vergi Dairesi Müdürlüğü",
              "Rıhtım Veraset ve Harçlar Vergi Dairesi Müdürlüğü",
              "Güngören Vergi Dairesi Müdürlüğü",
              "Kocasinan Vergi Dairesi Müdürlüğü",
              "Güneşli Vergi Dairesi Müdürlüğü",
              "Küçükyalı Vergi Dairesi Müdürlüğü",
              "Pendik Vergi Dairesi Müdürlüğü",
              "Bayrampaşa Vergi Dairesi Müdürlüğü",
              "Beyazıt Vergi Dairesi Müdürlüğü",
              "Beyoğlu Vergi Dairesi Müdürlüğü",
              "Gaziosmanpaşa Vergi Dairesi Müdürlüğü",
              "Göztepe Vergi Dairesi Müdürlüğü",
              "Hocapaşa Vergi Dairesi Müdürlüğü",
              "Kadıköy Vergi Dairesi Müdürlüğü",
              "Kocamustafapaşa Vergi Dairesi Müdürlüğü",
              "Mecidiyeköy Vergi Dairesi Müdürlüğü",
              "Şişli Vergi Dairesi Müdürlüğü",
              "Üsküdar Vergi Dairesi Müdürlüğü",
              "Halkalı Vergi Dairesi Müdürlüğü",
              "Kağıthane Vergi Dairesi Müdürlüğü",
              "Zeytinburnu Vergi Dairesi Müdürlüğü",
              "Beykoz Vergi Dairesi Müdürlüğü",
              "Sarıyer Vergi Dairesi Müdürlüğü",
              "Bakırköy Vergi Dairesi Müdürlüğü",
              "Kartal Vergi Dairesi Müdürlüğü",
              "Nakil Vasıtaları Vergi Dairesi Müdürlüğü",
              "Sarıgazi Vergi Dairesi Müdürlüğü",
              "Atışalanı Vergi Dairesi Müdürlüğü",
              "Yakacık Vergi Dairesi Müdürlüğü",
              "Yenibosna Vergi Dairesi Müdürlüğü",
              "Avcılar Vergi Dairesi Müdürlüğü",
              "Adalar Vergi Dairesi Müdürlüğü",
              "Küçükçekmece Vergi Dairesi Müdürlüğü",
              "Beylikdüzü Vergi Dairesi Müdürlüğü",
              "Esenyurt Vergi Dairesi Müdürlüğü",
              "Başakşehir Vergi Dairesi Müdürlüğü",
              "Silivri Vergi Dairesi Müdürlüğü",
              "Büyükçekmece Vergi Dairesi Müdürlüğü",
              "Şile Vergi Dairesi Müdürlüğü"
          ],
          "İzmir": [
              "İzmir İhtisas Vergi Dairesi Müdürlüğü",
              "Eylül Vergi Dairesi Müdürlüğü",
              "Yamanlar Vergi Dairesi Müdürlüğü",
              "Belkahve Vergi Dairesi Müdürlüğü",
              "Karşıyaka Vergi Dairesi Müdürlüğü",
              "Kemeraltı Vergi Dairesi Müdürlüğü",
              "Konak Vergi Dairesi Müdürlüğü",
              "Kordon Vergi Dairesi Müdürlüğü",
              "Şirinyer Vergi Dairesi Müdürlüğü",
              "Kadifekale Vergi Dairesi Müdürlüğü",
              "Taşıtlar Vergi Dairesi Müdürlüğü",
              "Hasan Tahsin Vergi Dairesi Müdürlüğü",
              "Bornova Vergi Dairesi Müdürlüğü",
              "Balçova Vergi Dairesi Müdürlüğü",
              "Gaziemir Vergi Dairesi Müdürlüğü",
              "Ege Vergi Dairesi Müdürlüğü",
              "Çiğli Vergi Dairesi Müdürlüğü",
              "Çakabey İhtisas Vergi Dairesi Müdürlüğü",
              "Bayındır Vergi Dairesi Müdürlüğü",
              "Bergama Vergi Dairesi Müdürlüğü",
              "Menemen Vergi Dairesi Müdürlüğü",
              "Ödemiş Vergi Dairesi Müdürlüğü",
              "Tire Vergi Dairesi Müdürlüğü",
              "Torbalı Vergi Dairesi Müdürlüğü",
              "Kemalpaşa Vergi Dairesi Müdürlüğü",
              "Urla Vergi Dairesi Müdürlüğü",
              "Selçuk Vergi Dairesi Müdürlüğü",
              "Kınık Vergi Dairesi Müdürlüğü",
              "Kiraz Vergi Dairesi Müdürlüğü",
              "Çeşme Vergi Dairesi Müdürlüğü",
              "Aliağa Vergi Dairesi Müdürlüğü",
              "Menderes Vergi Dairesi Müdürlüğü",
              "Dikili  Vergi Dairesi Müdürlüğü",
              "Seferihisar Vergi Dairesi Müdürlüğü",
              "Foça Vergi Dairesi Müdürlüğü",
              "Karaburun Vergi Dairesi Müdürlüğü",
              "Beydağ Vergi Dairesi Müdürlüğü"
          ],
          "Kars": [
              "Kars Vergi Dairesi Müdürlüğü",
              "Sarıkamış Vergi Dairesi Müdürlüğü",
              "Kağızman Vergi Dairesi Müdürlüğü",
              "Arpaçay Malmüdürlüğü",
              "Digor Malmüdürlüğü",
              "Selim Malmüdürlüğü",
              "Susuz Malmüdürlüğü",
              "Akyaka Malmüdürlüğü"
          ],
          "Kastamonu": [
              "Kastamonu Vergi Dairesi Müdürlüğü",
              "Tosya Vergi Dairesi Müdürlüğü",
              "Taşköprü Vergi Dairesi Müdürlüğü",
              "Cide Vergi Dairesi Müdürlüğü",
              "İnebolu Vergi Dairesi Müdürlüğü",
              "Araç Vergi Dairesi Müdürlüğü",
              "Devrekani Vergi Dairesi Müdürlüğü",
              "Azdavay Malmüdürlüğü",
              "Bozkurt Malmüdürlüğü",
              "Çatalzeytin Malmüdürlüğü",
              "Daday Malmüdürlüğü",
              "Küre Malmüdürlüğü",
              "Abana Malmüdürlüğü",
              "İhsangazi Malmüdürlüğü",
              "Pınarbaşı Malmüdürlüğü",
              "Şenpazar Malmüdürlüğü",
              "Ağlı Malmüdürlüğü",
              "Doğanyurt Malmüdürlüğü",
              "Hanönü Malmüdürlüğü",
              "Seydiler Malmüdürlüğü"
          ],
          "Kayseri": [
              "Kayseri İhtisas Vergi Dairesi Müdürlüğü",
              "Mimar Sinan Vergi Dairesi Müdürlüğü",
              "Erciyes Vergi Dairesi Müdürlüğü",
              "Kaleönü Vergi Dairesi Müdürlüğü",
              "Gevher Nesibe Vergi Dairesi Müdürlüğü",
              "Develi Vergi Dairesi Müdürlüğü",
              "Pınarbaşı Vergi Dairesi Müdürlüğü",
              "Bünyan Vergi Dairesi Müdürlüğü",
              "Yahyalı Vergi Dairesi Müdürlüğü",
              "İncesu Vergi Dairesi Müdürlüğü",
              "Tomarza Vergi Dairesi Müdürlüğü",
              "Yeşilhisar Vergi Dairesi Müdürlüğü",
              "Felahiye Malmüdürlüğü",
              "Sarıoğlan Malmüdürlüğü",
              "Sarız Malmüdürlüğü",
              "Akkışla Malmüdürlüğü",
              "Hacılar Malmüdürlüğü",
              "Özvatan Malmüdürlüğü"
          ],
          "Kırklareli": [
              "Kırklareli Vergi Dairesi Müdürlüğü",
              "Lüleburgaz Vergi Dairesi Müdürlüğü",
              "Babaeski Vergi Dairesi Müdürlüğü",
              "Pınarhisar Vergi Dairesi Müdürlüğü",
              "Vize Vergi Dairesi Müdürlüğü",
              "Demirköy Vergi Dairesi Müdürlüğü",
              "Kofçaz Malmüdürlüğü",
              "Pehlivanköy Malmüdürlüğü"
          ],
          "Kırşehir": [
              "Kırşehir Vergi Dairesi Müdürlüğü",
              "Kaman Vergi Dairesi Müdürlüğü",
              "Mucur Vergi Dairesi Müdürlüğü",
              "Çiçekdağı Malmüdürlüğü",
              "Akpınar Malmüdürlüğü",
              "Akçakent Malmüdürlüğü",
              "Boztepe Malmüdürlüğü"
          ],
          "Kocaeli": [
              "Kocaeli İhtisas Vergi Dairesi Müdürlüğü",
              "Tepecik Vergi Dairesi Müdürlüğü",
              "Alemdar Vergi Dairesi Müdürlüğü",
              "Acısu Vergi Dairesi Müdürlüğü",
              "Gebze İhtisas Vergi Dairesi Müdürlüğü",
              "Uluçınar Vergi Dairesi Müdürlüğü",
              "İlyasbey Vergi Dairesi Müdürlüğü",
              "Gölcük Vergi Dairesi Müdürlüğü",
              "Karamürsel Vergi Dairesi Müdürlüğü",
              "Körfez Vergi Dairesi Müdürlüğü",
              "Derince Vergi Dairesi Müdürlüğü",
              "Kandıra Vergi Dairesi Müdürlüğü"
          ],
          "Konya": [
              "Konya İhtisas Vergi Dairesi Müdürlüğü",
              "Selçuk Vergi Dairesi Müdürlüğü",
              "Mevlana Vergi Dairesi Müdürlüğü",
              "Meram Vergi Dairesi Müdürlüğü",
              "Alaaddin Vergi Dairesi Müdürlüğü",
              "Akşehir Vergi Dairesi Müdürlüğü",
              "Ereğli Vergi Dairesi Müdürlüğü",
              "Beyşehir Vergi Dairesi Müdürlüğü",
              "Cihanbeyli Vergi Dairesi Müdürlüğü",
              "Çumra Vergi Dairesi Müdürlüğü",
              "Seydişehir Vergi Dairesi Müdürlüğü",
              "Ilgın Vergi Dairesi Müdürlüğü",
              "Kulu Vergi Dairesi Müdürlüğü",
              "Karapınar Vergi Dairesi Müdürlüğü",
              "Kadınhanı Vergi Dairesi Müdürlüğü",
              "Sarayönü Vergi Dairesi Müdürlüğü",
              "Bozkır Vergi Dairesi Müdürlüğü",
              "Yunak Vergi Dairesi Müdürlüğü",
              "Hüyük Vergi Dairesi Müdürlüğü",
              "Altınekin Vergi Dairesi Müdürlüğü",
              "Emirgazi Vergi Dairesi Müdürlüğü",
              "Doğanhisar Vergi Dairesi Müdürlüğü",
              "Hadim Malmüdürlüğü",
              "Akören Malmüdürlüğü",
              "Derebucak Malmüdürlüğü",
              "Taşkent Malmüdürlüğü",
              "Ahırlı Malmüdürlüğü",
              "Çeltik Malmüdürlüğü",
              "Derbent Malmüdürlüğü",
              "Güneysınır Malmüdürlüğü",
              "Halkapınar Malmüdürlüğü",
              "Tuzlukçu Malmüdürlüğü",
              "Yalıhüyük Malmüdürlüğü"
          ],
          "Kütahya": [
              "Ağustos Vergi Dairesi Müdürlüğü",
              "Çinili Vergi Dairesi Müdürlüğü",
              "Gediz Vergi Dairesi Müdürlüğü",
              "Simav Vergi Dairesi Müdürlüğü",
              "Tavşanlı Vergi Dairesi Müdürlüğü",
              "Emet Vergi Dairesi Müdürlüğü",
              "Altıntaş Vergi Dairesi Müdürlüğü",
              "Domaniç Malmüdürlüğü",
              "Aslanapa Malmüdürlüğü",
              "Dumlupınar Malmüdürlüğü",
              "Hisarcık Malmüdürlüğü",
              "Şaphane Malmüdürlüğü",
              "Çavdarhisar Malmüdürlüğü",
              "Pazarlar Malmüdürlüğü"
          ],
          "Malatya": [
              "Fırat Vergi Dairesi Müdürlüğü",
              "Beydağı Vergi Dairesi Müdürlüğü",
              "Doğanşehir Vergi Dairesi Müdürlüğü",
              "Darende Vergi Dairesi Müdürlüğü",
              "Akçadağ Vergi Dairesi Müdürlüğü",
              "Arapgir Malmüdürlüğü",
              "Arguvan Malmüdürlüğü",
              "Hekimhan Malmüdürlüğü",
              "Pütürge Malmüdürlüğü",
              "Doğanyol Malmüdürlüğü",
              "Kale Malmüdürlüğü",
              "Kuluncak Malmüdürlüğü",
              "Yazıhan Malmüdürlüğü"
          ],
          "Manisa": [
              "Manisa İhtisas Vergi Dairesi Müdürlüğü",
              "Şehit Cihan Güneş Vergi Dairesi Müdürlüğü",
              "Mesir Vergi Dairesi Müdürlüğü",
              "Akhisar Vergi Dairesi Müdürlüğü",
              "Alaşehir Vergi Dairesi Müdürlüğü",
              "Demirci Vergi Dairesi Müdürlüğü",
              "Kırkağaç Vergi Dairesi Müdürlüğü",
              "Salihli Adil Oral Vergi Dairesi Müdürlüğü",
              "Sarıgöl Vergi Dairesi Müdürlüğü",
              "Saruhanlı Vergi Dairesi Müdürlüğü",
              "Soma Vergi Dairesi Müdürlüğü",
              "Turgutlu Vergi Dairesi Müdürlüğü",
              "Gördes Vergi Dairesi Müdürlüğü",
              "Kula Vergi Dairesi Müdürlüğü",
              "Ahmetli Vergi Dairesi Müdürlüğü",
              "Gölmarmara Vergi Dairesi Müdürlüğü",
              "Selendi Vergi Dairesi Müdürlüğü",
              "Köprübaşı Vergi Dairesi Müdürlüğü"
          ],
          "Kahramanmaraş": [
              "Aslanbey Vergi Dairesi Müdürlüğü",
              "Aksu Vergi Dairesi Müdürlüğü",
              "Elbistan Vergi Dairesi Müdürlüğü",
              "Afşin Vergi Dairesi Müdürlüğü",
              "Pazarcık Vergi Dairesi Müdürlüğü",
              "Göksun Vergi Dairesi Müdürlüğü",
              "Andırın Vergi Dairesi Müdürlüğü",
              "Türkoğlu Vergi Dairesi Müdürlüğü",
              "Çağlayancerit Vergi Dairesi Müdürlüğü",
              "Ekinözü Malmüdürlüğü",
              "Nurhak Malmüdürlüğü"
          ],
          "Mardin": [
              "Mardin Vergi Dairesi Müdürlüğü",
              "Kızıltepe Vergi Dairesi Müdürlüğü",
              "Nusaybin Vergi Dairesi Müdürlüğü",
              "Midyat Vergi Dairesi Müdürlüğü",
              "Derik Vergi Dairesi Müdürlüğü",
              "Mazıdağı Vergi Dairesi Müdürlüğü",
              "Ömerli Malmüdürlüğü",
              "Savur Malmüdürlüğü",
              "Dargeçit Malmüdürlüğü",
              "Yeşilli Malmüdürlüğü"
          ],
          "Muğla": [
              "Muğla Vergi Dairesi Müdürlüğü",
              "Bodrum Vergi Dairesi Müdürlüğü",
              "Fethiye Vergi Dairesi Müdürlüğü",
              "Köyceğiz Vergi Dairesi Müdürlüğü",
              "Milas Vergi Dairesi Müdürlüğü",
              "Marmaris Vergi Dairesi Müdürlüğü",
              "Yatağan Vergi Dairesi Müdürlüğü",
              "Ortaca Vergi Dairesi Müdürlüğü",
              "Datça Vergi Dairesi Müdürlüğü",
              "Dalaman Vergi Dairesi Müdürlüğü",
              "Seydikemer Vergi Dairesi Müdürlüğü",
              "Ula Vergi Dairesi Müdürlüğü",
              "Kavaklıdere Vergi Dairesi Müdürlüğü"
          ],
          "Muş": [
              "Muş Vergi Dairesi Müdürlüğü",
              "Bulanık Vergi Dairesi Müdürlüğü",
              "Malazgirt Vergi Dairesi Müdürlüğü",
              "Varto  Vergi Dairesi Müdürlüğü",
              "Hasköy Malmüdürlüğü",
              "Korkut Malmüdürlüğü"
          ],
          "Nevşehir": [
              "Nevşehir Vergi Dairesi Müdürlüğü",
              "Ürgüp Vergi Dairesi Müdürlüğü",
              "Derinkuyu Vergi Dairesi Müdürlüğü",
              "Avanos Vergi Dairesi Müdürlüğü",
              "Gülşehir Vergi Dairesi Müdürlüğü",
              "Hacıbektaş Vergi Dairesi Müdürlüğü",
              "Acıgöl Vergi Dairesi Müdürlüğü",
              "Kozaklı Vergi Dairesi Müdürlüğü"
          ],
          "Niğde": [
              "Niğde Vergi Dairesi Müdürlüğü",
              "Bor Vergi Dairesi Müdürlüğü",
              "Ulukışla Vergi Dairesi Müdürlüğü",
              "Çiftlik Vergi Dairesi Müdürlüğü",
              "Altunhisar Vergi Dairesi Müdürlüğü",
              "Çamardı Malmüdürlüğü"
          ],
          "Ordu": [
              "Boztepe Vergi Dairesi Müdürlüğü",
              "Köprübaşı Vergi Dairesi Müdürlüğü",
              "Fatsa Vergi Dairesi Müdürlüğü",
              "Ünye Vergi Dairesi Müdürlüğü",
              "Aybastı Vergi Dairesi Müdürlüğü",
              "Gölköy Vergi Dairesi Müdürlüğü",
              "Korgan Vergi Dairesi Müdürlüğü",
              "Kumru Vergi Dairesi Müdürlüğü",
              "Perşembe Vergi Dairesi Müdürlüğü",
              "Akkuş Vergi Dairesi Müdürlüğü",
              "Çatalpınar Vergi Dairesi Müdürlüğü",
              "Mesudiye Malmüdürlüğü",
              "Ulubey Malmüdürlüğü",
              "Gülyalı Malmüdürlüğü",
              "Gürgentepe Malmüdürlüğü",
              "Çamaş Malmüdürlüğü",
              "Çaybaşı Malmüdürlüğü",
              "İkizce Malmüdürlüğü",
              "Kabadüz Malmüdürlüğü",
              "Kabataş Malmüdürlüğü"
          ],
          "Rize": [
              "Kaçkar Vergi Dairesi Müdürlüğü",
              "Yeşilçay Vergi Dairesi Müdürlüğü",
              "Çayeli Vergi Dairesi Müdürlüğü",
              "Pazar Vergi Dairesi Müdürlüğü",
              "Ardeşen Vergi Dairesi Müdürlüğü",
              "Fındıklı Vergi Dairesi Müdürlüğü",
              "Çamlıhemşin Vergi Dairesi Müdürlüğü",
              "İkizdere Malmüdürlüğü",
              "Kalkandere Malmüdürlüğü",
              "Güneysu Malmüdürlüğü",
              "Derepazarı Malmüdürlüğü",
              "Hemşin Malmüdürlüğü",
              "İyidere Malmüdürlüğü"
          ],
          "Sakarya": [
              "Sakarya İhtisas Vergi Dairesi Müdürlüğü",
              "Gümrükönü Vergi Dairesi Müdürlüğü",
              "Ali Fuat Cebesoy Vergi Dairesi Müdürlüğü",
              "Sapanca Vergi Dairesi Müdürlüğü",
              "Akyazı Vergi Dairesi Müdürlüğü",
              "Geyve Vergi Dairesi Müdürlüğü",
              "Hendek Vergi Dairesi Müdürlüğü",
              "Karasu Vergi Dairesi Müdürlüğü",
              "Pamukova Vergi Dairesi Müdürlüğü",
              "Kaynarca Vergi Dairesi Müdürlüğü",
              "Kocaali Vergi Dairesi Müdürlüğü",
              "Taraklı Malmüdürlüğü",
              "Karapürçek Malmüdürlüğü"
          ],
          "Samsun": [
              "Mayıs Vergi Dairesi Müdürlüğü",
              "Gaziler Vergi Dairesi Müdürlüğü",
              "Zafer Vergi Dairesi Müdürlüğü",
              "Bafra Vergi Dairesi Müdürlüğü",
              "Çarşamba Vergi Dairesi Müdürlüğü",
              "Terme Vergi Dairesi Müdürlüğü",
              "Havza Vergi Dairesi Müdürlüğü",
              "Vezirköprü Vergi Dairesi Müdürlüğü",
              "Mayıs Ballıca Vergi Dairesi Müdürlüğü",
              "Kavak Vergi Dairesi Müdürlüğü",
              "Salıpazarı Vergi Dairesi Müdürlüğü",
              "Alaçam Vergi Dairesi Müdürlüğü",
              "Ladik Malmüdürlüğü",
              "Asarcık Malmüdürlüğü",
              "Ayvacık Malmüdürlüğü",
              "Yakakent Malmüdürlüğü"
          ],
          "Siirt": [
              "Siirt Vergi Dairesi Müdürlüğü",
              "Kurtalan Vergi Dairesi Müdürlüğü",
              "Baykan Malmüdürlüğü",
              "Eruh Malmüdürlüğü",
              "Pervari Malmüdürlüğü",
              "Şirvan Malmüdürlüğü"
          ],
          "Sinop": [
              "Sinop Vergi Dairesi Müdürlüğü",
              "Boyabat Vergi Dairesi Müdürlüğü",
              "Ayancık Vergi Dairesi Müdürlüğü",
              "Gerze Vergi Dairesi Müdürlüğü",
              "Türkeli Vergi Dairesi Müdürlüğü",
              "Durağan Malmüdürlüğü",
              "Erfelek Malmüdürlüğü",
              "Dikmen Malmüdürlüğü",
              "Saraydüzü Malmüdürlüğü"
          ],
          "Sivas": [
              "Kale Vergi Dairesi Müdürlüğü",
              "Site Vergi Dairesi Müdürlüğü",
              "Şarkışla Vergi Dairesi Müdürlüğü",
              "Suşehri Vergi Dairesi Müdürlüğü",
              "Yıldızeli Vergi Dairesi Müdürlüğü",
              "Kangal Vergi Dairesi Müdürlüğü",
              "Zara Vergi Dairesi Müdürlüğü",
              "Gemerek Vergi Dairesi Müdürlüğü",
              "Gürün Vergi Dairesi Müdürlüğü",
              "Divriği Vergi Dairesi Müdürlüğü",
              "Hafik Malmüdürlüğü",
              "İmranlı Malmüdürlüğü",
              "Koyulhisar Malmüdürlüğü",
              "Akıncılar Malmüdürlüğü",
              "Altınyayla Malmüdürlüğü",
              "Doğanşar Malmüdürlüğü",
              "Gölova Malmüdürlüğü",
              "Ulaş Malmüdürlüğü"
          ],
          "Tekirdağ": [
              "Süleymanpaşa Vergi Dairesi Müdürlüğü",
              "Namık Kemal Vergi Dairesi Müdürlüğü",
              "Çorlu İhtisas Vergi Dairesi Müdürlüğü",
              "Çerkezköy Vergi Dairesi Müdürlüğü",
              "Çorlu Vergi Dairesi Müdürlüğü",
              "Hayrabolu Vergi Dairesi Müdürlüğü",
              "Malkara Vergi Dairesi Müdürlüğü",
              "Muratlı Vergi Dairesi Müdürlüğü",
              "Şarköy Vergi Dairesi Müdürlüğü",
              "Kapaklı Vergi Dairesi Müdürlüğü",
              "Saray Vergi Dairesi Müdürlüğü",
              "Marmaraereğlisi Vergi Dairesi Müdürlüğü"
          ],
          "Tokat": [
              "Tokat Vergi Dairesi Müdürlüğü",
              "Erbaa Vergi Dairesi Müdürlüğü",
              "Niksar Vergi Dairesi Müdürlüğü",
              "Turhal Vergi Dairesi Müdürlüğü",
              "Zile Vergi Dairesi Müdürlüğü",
              "Reşadiye Vergi Dairesi Müdürlüğü",
              "Almus Vergi Dairesi Müdürlüğü",
              "Artova Malmüdürlüğü",
              "Pazar Malmüdürlüğü",
              "Yeşilyurt Malmüdürlüğü",
              "Başçiftlik Malmüdürlüğü",
              "Sulusaray Malmüdürlüğü"
          ],
          "Trabzon": [
              "Hızırbey Vergi Dairesi Müdürlüğü",
              "Karadeniz Vergi Dairesi Müdürlüğü",
              "Akçaabat Vergi Dairesi Müdürlüğü",
              "Of Vergi Dairesi Müdürlüğü",
              "Vakfıkebir Vergi Dairesi Müdürlüğü",
              "Araklı Vergi Dairesi Müdürlüğü",
              "Yomra Vergi Dairesi Müdürlüğü",
              "Sürmene Vergi Dairesi Müdürlüğü",
              "Arsin Vergi Dairesi Müdürlüğü",
              "Çaykara Vergi Dairesi Müdürlüğü",
              "Maçka Vergi Dairesi Müdürlüğü",
              "Beşikdüzü Vergi Dairesi Müdürlüğü",
              "Çarşıbaşı Vergi Dairesi Müdürlüğü",
              "Tonya Malmüdürlüğü",
              "Şalpazarı Malmüdürlüğü",
              "Dernekpazarı Malmüdürlüğü",
              "Düzköy Malmüdürlüğü",
              "Hayrat Malmüdürlüğü",
              "Köprübaşı Malmüdürlüğü"
          ],
          "Tunceli": [
              "Tunceli Vergi Dairesi Müdürlüğü",
              "Çemişgezek Malmüdürlüğü",
              "Hozat Malmüdürlüğü",
              "Mazgirt Malmüdürlüğü",
              "Nazımiye Malmüdürlüğü",
              "Ovacık Malmüdürlüğü",
              "Pertek Malmüdürlüğü",
              "Pülümür Malmüdürlüğü"
          ],
          "Şanlıurfa": [
              "Şehitlik Vergi Dairesi Müdürlüğü",
              "Topçu Meydanı Vergi Dairesi Müdürlüğü",
              "Göbeklitepe Vergi Dairesi Müdürlüğü",
              "Siverek Vergi Dairesi Müdürlüğü",
              "Viranşehir Vergi Dairesi Müdürlüğü",
              "Birecik Vergi Dairesi Müdürlüğü",
              "Suruç Vergi Dairesi Müdürlüğü",
              "Ceylanpınar Vergi Dairesi Müdürlüğü",
              "Akçakale Vergi Dairesi Müdürlüğü",
              "Hilvan Vergi Dairesi Müdürlüğü",
              "Bozova Vergi Dairesi Müdürlüğü",
              "Halfeti Vergi Dairesi Müdürlüğü",
              "Harran Vergi Dairesi Müdürlüğü"
          ],
          "Uşak": [
              "Uşak Vergi Dairesi Müdürlüğü",
              "Banaz Vergi Dairesi Müdürlüğü",
              "Eşme Vergi Dairesi Müdürlüğü",
              "Sivaslı Vergi Dairesi Müdürlüğü",
              "Ulubey Vergi Dairesi Müdürlüğü",
              "Karahallı Malmüdürlüğü"
          ],
          "Van": [
              "Van Vergi Dairesi Müdürlüğü",
              "Erciş Vergi Dairesi Müdürlüğü",
              "Özalp Vergi Dairesi Müdürlüğü",
              "Çaldıran Vergi Dairesi Müdürlüğü",
              "Edremit Vergi Dairesi Müdürlüğü",
              "Muradiye Vergi Dairesi Müdürlüğü",
              "Gevaş Vergi Dairesi Müdürlüğü",
              "Gürpınar Vergi Dairesi Müdürlüğü",
              "Başkale Vergi Dairesi Müdürlüğü",
              "Çatak Malmüdürlüğü",
              "Bahçesaray Malmüdürlüğü",
              "Saray Malmüdürlüğü"
          ],
          "Yozgat": [
              "Yozgat Vergi Dairesi Müdürlüğü",
              "Boğazlıyan Vergi Dairesi Müdürlüğü",
              "Sorgun Vergi Dairesi Müdürlüğü",
              "Yerköy Vergi Dairesi Müdürlüğü",
              "Akdağmadeni Vergi Dairesi Müdürlüğü",
              "Şefaatli Vergi Dairesi Müdürlüğü",
              "Sarıkaya Vergi Dairesi Müdürlüğü",
              "Çekerek Vergi Dairesi Müdürlüğü",
              "Çayıralan Malmüdürlüğü",
              "Aydıncık Malmüdürlüğü",
              "Çandır Malmüdürlüğü",
              "Kadışehri Malmüdürlüğü",
              "Saraykent Malmüdürlüğü",
              "Yenifakılı Malmüdürlüğü"
          ],
          "Zonguldak": [
              "Uzunmehmet Vergi Dairesi Müdürlüğü",
              "Kara Elmas Vergi Dairesi Müdürlüğü",
              "Ereğli Vergi Dairesi Müdürlüğü",
              "Çaycuma Vergi Dairesi Müdürlüğü",
              "Devrek Vergi Dairesi Müdürlüğü",
              "Alaplı Vergi Dairesi Müdürlüğü",
              "Gökçebey Vergi Dairesi Müdürlüğü"
          ],
          "Aksaray": [
              "Aksaray Vergi Dairesi Müdürlüğü",
              "Ortaköy Vergi Dairesi Müdürlüğü",
              "Eskil Vergi Dairesi Müdürlüğü",
              "Gülağaç Vergi Dairesi Müdürlüğü",
              "Ağaçören Malmüdürlüğü",
              "Güzelyurt Malmüdürlüğü",
              "Sarıyahşi Malmüdürlüğü",
              "Sultanhanı Malmüdürlüğü"
          ],
          "Bayburt": [
              "Bayburt Vergi Dairesi Müdürlüğü",
              "Aydıntepe Malmüdürlüğü",
              "Demirözü Malmüdürlüğü"
          ],
          "Karaman": [
              "Karaman Vergi Dairesi Müdürlüğü",
              "Ermenek Vergi Dairesi Müdürlüğü",
              "Ayrancı Malmüdürlüğü",
              "Kazım Karabekir Malmüdürlüğü",
              "Başyayla Malmüdürlüğü",
              "Sarıveliler Malmüdürlüğü"
          ],
          "Kırıkkale": [
              "Irmak Vergi Dairesi Müdürlüğü",
              "Kaletepe Vergi Dairesi Müdürlüğü",
              "Keskin Vergi Dairesi Müdürlüğü",
              "Delice Malmüdürlüğü",
              "Sulakyurt Malmüdürlüğü",
              "Balışeyh Malmüdürlüğü",
              "Çelebi Malmüdürlüğü",
              "Karakeçili Malmüdürlüğü"
          ],
          "Batman": [
              "Batman Vergi Dairesi Müdürlüğü",
              "Kozluk Vergi Dairesi Müdürlüğü",
              "Beşiri Malmüdürlüğü",
              "Gercüş Malmüdürlüğü",
              "Hasankeyf Malmüdürlüğü",
              "Sason Malmüdürlüğü"
          ],
          "Şırnak": [
              "Şırnak Vergi Dairesi Müdürlüğü",
              "Cizre Vergi Dairesi Müdürlüğü",
              "Silopi Vergi Dairesi Müdürlüğü",
              "Uludere Vergi Dairesi Müdürlüğü",
              "İdil Vergi Dairesi Müdürlüğü",
              "Beytüşşebap Malmüdürlüğü",
              "Güçlükonak Malmüdürlüğü"
          ],
          "Bartın": [
              "Bartın Vergi Dairesi Müdürlüğü",
              "Ulus Vergi Dairesi Müdürlüğü",
              "Amasra Vergi Dairesi Müdürlüğü",
              "Kurucaşile Malmüdürlüğü"
          ],
          "Ardahan": [
              "Ardahan Vergi Dairesi Müdürlüğü",
              "Göle Vergi Dairesi Müdürlüğü",
              "Çıldır Malmüdürlüğü",
              "Damal Malmüdürlüğü",
              "Hanak Malmüdürlüğü",
              "Posof Malmüdürlüğü"
          ],
          "Iğdır": [
              "Iğdır Vergi Dairesi Müdürlüğü",
              "Aralık Malmüdürlüğü",
              "Karakoyunlu Malmüdürlüğü",
              "Tuzluca Malmüdürlüğü"
          ],
          "Yalova": [
              "Yalova Vergi Dairesi Müdürlüğü",
              "Çınarcık Vergi Dairesi Müdürlüğü",
              "Altınova Vergi Dairesi Müdürlüğü",
              "Armutlu Vergi Dairesi Müdürlüğü"
          ],
          "Karabük": [
              "Karabük Vergi Dairesi Müdürlüğü",
              "Safranbolu Vergi Dairesi Müdürlüğü",
              "Yenice Vergi Dairesi Müdürlüğü",
              "Eskipazar Vergi Dairesi Müdürlüğü",
              "Eflani Malmüdürlüğü",
              "Ovacık Malmüdürlüğü"
          ],
          "Kilis": [
              "Kilis Vergi Dairesi Müdürlüğü"
          ],
          "Osmaniye": [
              "Osmaniye Vergi Dairesi Müdürlüğü",
              "Kadirli Vergi Dairesi Müdürlüğü",
              "Düziçi Vergi Dairesi Müdürlüğü",
              "Bahçe Vergi Dairesi Müdürlüğü",
              "Hasanbeyli Malmüdürlüğü",
              "Sumbas Malmüdürlüğü",
              "Toprakkale Malmüdürlüğü"
          ],
          "Düzce": [
              "Düzce Vergi Dairesi Müdürlüğü",
              "Akçakoca Vergi Dairesi Müdürlüğü",
              "Gölyaka Vergi Dairesi Müdürlüğü",
              "Kaynaşlı Vergi Dairesi Müdürlüğü",
              "Gümüşova Vergi Dairesi Müdürlüğü",
              "Cumayeri Vergi Dairesi Müdürlüğü",
              "Çilimli Vergi Dairesi Müdürlüğü",
              "Yığılca Malmüdürlüğü"
          ]
      };

      const citySelect = document.getElementById("form_input_5");
      const taxSelect = document.getElementById("form_input_6");
      if (!citySelect || !taxSelect) return;

      const taxNumberInput = document.getElementById("form_input_7");
      
      function validateTaxNumber(value) {
          if (!/^\d*$/.test(value)) {
              return false;
          }
          
          if (value.length > 0 && value.length !== 10) {
              return false;
          }
          
          if (value.length > 0) {
              let consecutiveCount = 1;
              for (let i = 1; i < value.length; i++) {
                  if (value[i] === value[i - 1]) {
                      consecutiveCount++;
                      if (consecutiveCount > 5) {
                          return false;
                      }
                  } else {
                      consecutiveCount = 1;
                  }
              }
              
              // Check for arithmetic sequences longer than 5 numbers
              for (let i = 0; i <= value.length - 6; i++) {
                  let isArithmeticSequence = true;
                  const firstDiff = parseInt(value[i + 1]) - parseInt(value[i]);
                  
                  for (let j = i + 1; j < i + 5; j++) {
                      const currentDiff = parseInt(value[j + 1]) - parseInt(value[j]);
                      if (currentDiff !== firstDiff) {
                          isArithmeticSequence = false;
                          break;
                      }
                  }
                  
                  if (isArithmeticSequence) {
                      return false;
                  }
              }
          }
          
          return true;
      }
      
      function updateTaxInputState() {
          if (!taxNumberInput) return;
          
          const taxValue = taxNumberInput.value;
          const isValid = validateTaxNumber(taxValue) && taxValue.length === 10;
          
          if (isValid) {
              taxNumberInput.classList.remove('error');
          } else if (taxValue.length > 0) {
              taxNumberInput.classList.add('error');
          }
      }
      
      if (taxNumberInput) {
          taxNumberInput.addEventListener('input', function(e) {
              const value = e.target.value;
              
              const digitsOnly = value.replace(/\D/g, '');
              if (value !== digitsOnly) {
                  e.target.value = digitsOnly;
              }
              
              updateTaxInputState();
          });
          
          taxNumberInput.addEventListener('keypress', function(e) {
              if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
                  (e.keyCode === 65 && e.ctrlKey === true) ||
                  (e.keyCode === 67 && e.ctrlKey === true) ||
                  (e.keyCode === 86 && e.ctrlKey === true) ||
                  (e.keyCode === 88 && e.ctrlKey === true)) {
                  return;
              }
              if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                  e.preventDefault();
              }
          });
          
          taxNumberInput.addEventListener('blur', function(e) {
              const taxValue = e.target.value;
              
              if (taxValue.length > 0 && (!validateTaxNumber(taxValue) || taxValue.length !== 10)) {
                  e.target.value = '';
                  alert('Vergi numarası geçerli değil. Lütfen 10 haneli geçerli bir vergi numarası giriniz.');
              }
          });
      }
      
      citySelect.addEventListener("change", function() {
          const selectedCity = this.value.trim();
          const districts = taxOfficesByDistrict[selectedCity] || [];

          taxSelect.innerHTML = "";
          const defaultOpt = document.createElement("option");
          defaultOpt.value = "";
          defaultOpt.textContent = districts[0];
          taxSelect.appendChild(defaultOpt);

          districts.forEach(d => {
              const o = document.createElement("option");
              o.value = d;
              o.textContent = d;
              taxSelect.appendChild(o);
          });
          
      });

      /* districtSelect.addEventListener("change", function() {
          console.log("İlçe değişti");
          const selectedCity = citySelect.value.trim();
          const selectedDistrict = this.value.trim();
          const taxOffices = (taxOfficesByDistrict[selectedCity] || {})[selectedDistrict] || [];

          taxSelect.innerHTML = "";
          const defTax = document.createElement("option");
          defTax.value = "";
          defTax.textContent = "Vergi dairesi seçin";
          taxSelect.appendChild(defTax);

          taxOffices.forEach(t => {
              const o = document.createElement("option");
              o.value = t;
              o.textContent = t;
              taxSelect.appendChild(o);
          });
      }); */
  });
})();

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  FoxTheme.focusVisiblePolyfill();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    if (!oldNode || !newContent) return;
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
class PageTransition extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('beforeunload', () => {
      document.body.classList.add('page-loading');
    });

    window.addEventListener('DOMContentLoaded', () => {
      FoxTheme.Motion.animate(this, { visibility: 'hidden', opacity: 0 }, { duration: 1 });

      document.body.classList.add('page-loaded');
      document.dispatchEvent(new CustomEvent('page:loaded'));
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        document.body.classList.remove('page-loading');
      }
    });
  }
}
customElements.define('page-transition', PageTransition);

const clearModalComponentCount = new WeakMap();
class ModalComponent extends HTMLElement {
  constructor() {
    super();
    this.events = {
      handleAfterHide: 'modal:handleAfterHide',
      handleAfterShow: 'modal:handleAfterShow',
    };

    this.classes = {
      show: 'modal-show',
      showing: 'modal-showing',
    };
  }

  static get observedAttributes() {
    return ['id', 'open'];
  }

  get isLockingNeeded() {
    return false;
  }

  get requiresBodyAppended() {
    return false;
  }

  get controls() {
    return Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`));
  }

  get designMode() {
    return this.hasAttribute('shopify-design-mode');
  }

  get open() {
    return this.hasAttribute('open');
  }

  get overlay() {
    // Check if the _overlay property is already set
    if (!this._overlay) {
      // If not set, find the element and cache it
      this._overlay = this.querySelector('.fixed-overlay');
    }

    // Return the cached element
    return this._overlay;
  }

  get focusElement() {
    return this.querySelector('button');
  }
  connectedCallback() {
    // Initialize the AbortController
    this.abortController = new AbortController();

    // Add click event listeners to all controls
    this.controls.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this), {
        signal: this.abortController.signal,
      });
    });

    // Add keyup event listener to document for handling the Escape key
    document.addEventListener(
      'keyup',
      (event) => {
        if (event.code === 'Escape') {
          this.hide();
        }
      },
      { signal: this.abortController.signal }
    );

    // Additional setup for Shopify design mode
    if (this.designMode && Shopify.designMode) {
      const section = this.closest('.shopify-section');
      section.addEventListener(
        'shopify:section:select',
        (event) => {
          this.show(null, !event.detail.load);
        },
        {
          signal: this.abortController.signal,
        }
      );
      section.addEventListener(
        'shopify:section:deselect',
        () => {
          this.hide();
        },
        {
          signal: this.abortController.signal,
        }
      );
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'open':
        this.controls.forEach((button) => button.setAttribute('aria-expanded', newValue === null ? 'false' : 'true'));

        if (oldValue === null && (newValue === '' || newValue === 'immediate')) {
          this.hidden = false;
          this.removeAttribute('inert');

          this.parentElementBeforeAppend = null;
          if (this.requiresBodyAppended && this.parentElement !== document.body) {
            this.parentElementBeforeAppend = this.parentElement;
            document.body.append(this);
          }
          const handleShowTransitionPromise = this.handleShowTransition(newValue !== 'immediate') || Promise.resolve();
          handleShowTransitionPromise.then(() => {
            this.handleAfterShow();
            this.dispatchEvent(new CustomEvent(this.events.handleAfterShow, { bubbles: true }));
          });
        } else if (oldValue !== null && newValue === null) {
          this.setAttribute('inert', '');

          const handleHideTransitionPromise = this.handleHideTransition() || Promise.resolve();
          handleHideTransitionPromise.then(() => {
            this.handleAfterHide();

            if (!this.hasAttribute('inert')) return;

            if (this.parentElement === document.body && this.parentElementBeforeAppend) {
              this.parentElementBeforeAppend.appendChild(this);
              this.parentElementBeforeAppend = null;
            }
            this.dispatchEvent(new CustomEvent(this.events.handleAfterHide, { bubbles: true }));

            this.hidden = true;
          });
        }
        this.dispatchEvent(new CustomEvent('toggle', { bubbles: true }));

        break;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.disabled) {
      return;
    }

    if (this.open) {
      this.hide();
    } else {
      this.show(event.currentTarget);
    }
  }

  hide() {
    if (this.open) {
      this.removeAttribute('open');
      return FoxTheme.utils.waitForEvent(this, this.events.handleAfterHide);
    }
  }

  show(activeElement = null, animate = true) {
    if (!this.shouleBeShow()) {
      return;
    }

    if (!this.open) {
      this.prepareToShow();
      this.activeElement = activeElement;
      this.setAttribute('open', animate ? '' : 'immediate');

      if (this.isLockingNeeded) {
        document.body.classList.add(this.classes.showing);
      }

      return FoxTheme.utils.waitForEvent(this, this.events.handleAfterShow);
    }
  }

  handleAfterHide() {
    setTimeout(() => {
      // Remove trap focus from the active element
      FoxTheme.a11y.removeTrapFocus(this.activeElement);

      // Conditionally manage locking behavior
      if (this.isLockingNeeded) {
        // Decrement the lock layer count for the ModalElement
        const currentModalCount = clearModalComponentCount.get(ModalComponent) - 1;
        clearModalComponentCount.set(ModalComponent, currentModalCount);

        // Toggle the 'open' class on the body based on the current lock count
        document.body.classList.toggle(this.classes.show, currentModalCount > 0);
      }
    });
  }

  handleAfterShow() {
    // Trap focus on the specified elements
    if (!Shopify.designMode) {
      FoxTheme.a11y.trapFocus(this, this.focusElement);
    }

    // Check if locking is needed
    if (this.isLockingNeeded) {
      // Increment the lock layer count for the ModalElement
      const currentLockCount = clearModalComponentCount.get(ModalComponent) + 1;
      clearModalComponentCount.set(ModalComponent, currentLockCount);

      // Manage class changes on the document body
      document.body.classList.remove(this.classes.showing);
      document.body.classList.add(this.classes.show);
    }
  }

  shouleBeShow() {
    return true;
  }

  prepareToShow() {}

  handleShowTransition() {
    // Start a timeout to set an attribute
    setTimeout(() => {
      this.setAttribute('active', '');
    }, 75);

    // Return a promise that resolves when the transition ends
    return new Promise((resolve) => {
      this.overlay.addEventListener('transitionend', resolve, { once: true });
    });
  }

  handleHideTransition() {
    // Immediately remove the 'active' attribute
    this.removeAttribute('active');

    // Return a promise that resolves when the transition ends
    return new Promise((resolve) => {
      this.overlay.addEventListener('transitionend', resolve, { once: true });
    });
  }
}
customElements.define('modal-component', ModalComponent);
clearModalComponentCount.set(ModalComponent, 0);

class BasicModal extends ModalComponent {
  constructor() {
    super();
  }

  get isLockingNeeded() {
    return true;
  }

  get requiresBodyAppended() {
    return true;
  }
}
customElements.define('basic-modal', BasicModal);

class DrawerComponent extends ModalComponent {
  constructor() {
    super();
    this.events = {
      handleAfterHide: 'drawer:handleAfterHide',
      handleAfterShow: 'drawer:handleAfterShow',
    };
  }
  get isLockingNeeded() {
    return true;
  }
  get requiresBodyAppended() {
    return true;
  }
}
customElements.define('drawer-component', DrawerComponent);

class SpotlightPick extends DrawerComponent {
  constructor() {
    super();
  }

  get requiresBodyAppended() {
    return false;
  }

  get toggleButton() {
    return this.controls.find((control) => control.hasAttribute('data-toggle-spotlight'));
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.toggleButton) {
      this.toggleTeaser(this.toggleButton, false, 0);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const { target, currentTarget } = event;
    if (target.hasAttribute('data-close-teaser')) {
      this.toggleTeaser(this.toggleButton, true);
      return;
    }

    super.onButtonClick(event);
  }

  toggleTeaser(toggleEl, shouldHide, hideDurationHours = 4) {
    const currentTime = new Date().getTime();
    const hideDuration = hideDurationHours * 60 * 60 * 1000;

    if (shouldHide) {
      toggleEl.classList.add('hidden');
      localStorage.setItem('spotlight:teaserHidden', 'true');
      localStorage.setItem('spotlight:teaserHideTime', currentTime);
      localStorage.setItem('spotlight:teaserHideDuration', hideDuration);
    } else {
      const teaserHidden = localStorage.getItem('spotlight:teaserHidden');
      const teaserHideTime = localStorage.getItem('spotlight:teaserHideTime');
      const teaserHideDuration = localStorage.getItem('spotlight:teaserHideDuration');

      if (teaserHidden === 'true' && teaserHideTime) {
        const timeElapsed = currentTime - parseInt(teaserHideTime);

        if (timeElapsed < parseInt(teaserHideDuration)) {
          toggleEl.classList.add('hidden');
        } else {
          localStorage.removeItem('spotlight:teaserHidden');
          localStorage.removeItem('spotlight:teaserHideTime');
          localStorage.removeItem('spotlight:teaserHideDuration');
          toggleEl.classList.remove('hidden');
        }
      } else {
        toggleEl.classList.remove('hidden');
      }
    }
  }
}
customElements.define('spotlight-pick', SpotlightPick);

class AccordionDetails extends HTMLDetailsElement {
  constructor() {
    super();
    this.initAccordion();
  }

  initAccordion() {
    this.isOpen = this.hasAttribute('open');
    this.summaryElement = this.querySelector('summary');
    this.contentElement = this.querySelector('summary + *');

    // Set aria-expanded on summary element for screen reader accessibility
    this.summaryElement.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');

    // Set aria-controls on summary if content has an id
    if (this.contentElement && this.contentElement.id) {
      this.summaryElement.setAttribute('aria-controls', this.contentElement.id);
    }

    this.summaryElement.addEventListener('click', this.toggleAccordion.bind(this));

    if (Shopify.designMode) {
      this.designModeEventSetup();
    }
  }

  static get observedAttributes() {
    return ['open'];
  }

  get open() {
    return this.isOpen;
  }

  set open(value) {
    if (value !== this.isOpen) {
      this.isOpen = value;

      if (this.isConnected) {
        this.animateAccordion(value);
      } else {
        if (value) {
          this.setAttribute('open', '');
        } else {
          this.removeAttribute('open');
        }
      }

      // Set aria-expanded on summary element for screen reader accessibility
      this.summaryElement.setAttribute('aria-expanded', value ? 'true' : 'false');

      this.handleAfterToggle();
    }
  }

  handleAfterToggle() {}

  toggleAccordion(event) {
    event.preventDefault();
    this.open = !this.open;
  }

  close() {
    this.isOpen = false;
    this.animateAccordion(false);
  }

  async animateAccordion(isOpen) {
    this.style.overflow = 'hidden';

    if (isOpen) {
      this.setAttribute('open', '');
      this.parentElement.classList.add('active');

      await FoxTheme.Motion.timeline([
        [
          this,
          { height: [`${this.summaryElement.clientHeight + 1}px`, `${this.scrollHeight + 1}px`] },
          { duration: 0.25, easing: 'ease' },
        ],
        [
          this.contentElement,
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
          { duration: 0.15, at: '<' },
        ],
      ]).finished;
    } else {
      await FoxTheme.Motion.timeline([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [
          this,
          { height: [`${this.clientHeight + 1}px`, `${this.summaryElement.clientHeight + 1}px`] },
          { duration: 0.25, at: '<', easing: 'ease' },
        ],
      ]).finished;

      this.removeAttribute('open');
      this.parentElement.classList.remove('active');
    }

    this.style.height = 'auto';
    this.style.overflow = 'visible';
  }

  designModeEventSetup() {
    this.addEventListener('shopify:block:select', () => {
      this.open = true;
    });

    this.addEventListener('shopify:block:deselect', () => {
      this.open = false;
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open' && this.summaryElement && this.contentElement && this.contentElement.id) {
      this.summaryElement.setAttribute('aria-controls', this.contentElement.id);
    }
  }
}
customElements.define('accordion-details', AccordionDetails, { extends: 'details' });

class AccordionGroup extends AccordionDetails {
  constructor() {
    super();
  }

  handleAfterToggle() {
    if (this.isOpen) {
      const parent = this.closest('.accordion-parent') || document;
      const siblingsAccordions = parent.querySelectorAll('details[is="accordion-group"]');

      siblingsAccordions.forEach((details) => {
        if (details !== this) {
          details.open = false;
        }
      });
    }
  }
}
customElements.define('accordion-group', AccordionGroup, { extends: 'details' });

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    if (this.hasAttribute('style')) return;

    if (this.dataset.from) {
      this.initProgress();
    }

    FoxTheme.Motion.inView(this, this.init.bind(this));
  }

  init() {
    this.setPercentage(this.dataset.value, this.dataset.max);
  }

  initProgress() {
    this.setPercentage(this.dataset.from, this.dataset.max);
  }

  setPercentage(val1, val2) {
    this.style.setProperty('--percent', `${(parseInt(val1) / parseInt(val2)) * 100}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartCount extends HTMLElement {
  constructor() {
    super();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  get itemCount() {
    return parseInt(this.innerText);
  }

  get type() {
    return this.dataset.type;
  }

  onCartUpdate(event) {
    // drawer carttan ve sepet sayfasından limitten fazla ekleme yaparken çalışıyor
    if (event.cart.errors) {
      this.handleCartError(event.cart, event.target);
      return;
    }
    let count = event.cart.item_count > 99 ? '99+' : event.cart.item_count;

    if (this.type === 'blank') {
      count = `(${count})`;
    }
    if (this.classList.contains('cart-count--absolute')) {
      if (event.cart.item_count > 99) {
        this.innerHTML = `<span class="text-sm-extra">${count}</span>`;
        this.classList.add('cart-count--small-medium');
      } else {
        this.innerText = count;
        this.classList.remove('cart-count--small-medium');
      }
    } else {
      this.innerText = count;
    }
    this.hidden = this.itemCount === 0 || event.cart.item_count === 0;
    const method = this.itemCount === 0 ? 'remove' : 'add';
    document.documentElement.classList[method]('cart-has-items');
  }

  handleCartError(cart, target = null) {
    // Publish cart error event via pub/sub system
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: 'cart-count',
      errors: cart.errors,
      message: cart.errors
    });

    // Dispatch custom product-ajax:error event
    document.dispatchEvent(
      new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: cart.errors,
        },
      })
    );

    // Show error message in cart drawer for specific item or all items
    this.showCartDrawerError(cart.errors, target);
  }

  showCartDrawerError(errorMessage, target = null) {
    // Get the appropriate error message (custom or auto)
    const finalErrorMessage = this.getErrorMessage(errorMessage);
    
    // Check the stock limit display method setting
    const displayMethod = FoxTheme?.settings?.stockLimitDisplayMethod || 'text';
    
    if (displayMethod === 'popup') {
      // Show popup modal
      const stockErrorModal = document.getElementById('StockErrorModal');
      if (stockErrorModal) {
        stockErrorModal.show(finalErrorMessage);
      }
      return;
    }
    
    // Default text behavior
    let targetContainers = [];
    
    if (target) {
      // Try to find the specific cart item that caused the error
      let cartItem = null;
      let itemNumber = null;
      
      // Check for cart drawer item first
      cartItem = target.closest('[id^="CartDrawer-Item-"]');
      if (cartItem) {
        itemNumber = cartItem.id.replace('CartDrawer-Item-', '');
        // Find the corresponding error container for cart drawer
        const drawerErrorContainer = document.querySelector(`[id$="-${itemNumber}"][id^="CartDrawer-ItemError-"]`);
        if (drawerErrorContainer) {
          targetContainers.push(drawerErrorContainer);
        }
      }
      
      // Check for main cart item
      cartItem = target.closest('[id^="CartItem-"]');
      if (cartItem) {
        itemNumber = cartItem.id.replace('CartItem-', '');
        // Find the corresponding error container for main cart
        const mainCartErrorContainer = document.querySelector(`[id$="-${itemNumber}"][id^="CartItem-ItemError-"]`);
        if (mainCartErrorContainer) {
          targetContainers.push(mainCartErrorContainer);
        }
      }
    }
    
    // If no specific target found or no target provided, show error for all cart items
    if (targetContainers.length === 0) {
      // Get all cart drawer and main cart error containers
      const drawerContainers = document.querySelectorAll('[id^="CartDrawer-ItemError-"]');
      const mainCartContainers = document.querySelectorAll('[id^="CartItem-ItemError-"]');
      targetContainers = [...drawerContainers, ...mainCartContainers];
    }
    
    targetContainers.forEach(container => {
      if (container) {
        const errorTextElement = container.querySelector('.cart-error-message__text');
        if (errorTextElement) {
          errorTextElement.textContent = finalErrorMessage;
          container.classList.remove('hidden');
          
          // Auto-hide the error message after 5 seconds
          setTimeout(() => {
            container.classList.add('hidden');
          }, 5000);
        }
      }
    });
  }
  // Helper function to get the appropriate error message
  getErrorMessage(originalMessage) {
    const messageSource = FoxTheme?.settings?.stockErrorMessageSource || 'auto';
    
    if (messageSource === 'custom') {
      const customMessage = FoxTheme?.settings?.stockErrorCustomMessage;
      return customMessage && customMessage.trim() !== '' ? customMessage : originalMessage;
    }
    
    return originalMessage;
  }
}
customElements.define('cart-count', CartCount);

// Stock Error Modal Component
class StockErrorModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onOverlayClick.bind(this));
    this.addEventListener('keydown', this.onKeyDown.bind(this));
    this.closeBtn = this.querySelector('.drawer__close-btn');
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }
  }

  show(errorMessage) {
    const messageElement = this.querySelector('.stock-error-popup__message');
    if (messageElement) {
      messageElement.textContent = errorMessage;
    }
    
    // Follow the same pattern as other modals in the theme
    this.setAttribute('open', '');
    this.removeAttribute('hidden');
    
    // Add body classes for modal state
    document.body.classList.add('modal-open', 'modal-show');
    
    // Trigger animation by setting active state after a small delay
    requestAnimationFrame(() => {
      this.setAttribute('active', '');
    });
    
    this.focus();
    
    // Trap focus within modal
    this.trapFocus();
  }

  hide() {
    this.removeAttribute('open');
    this.removeAttribute('active');
    this.setAttribute('hidden', '');
    document.body.classList.remove('modal-open', 'modal-show');
  }

  onOverlayClick(event) {
    if (event.target === this || event.target.classList.contains('fixed-overlay')) {
      this.hide();
    }
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.hide();
    }
  }

  trapFocus() {
    const focusableElements = this.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  }
}
customElements.define('stock-error-modal', StockErrorModal);

class QuantityInput extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;
  quantityBoundriesUnsubscriber = undefined;
  quantityRulesUnsubscriber = undefined;

  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  get productId() {
    return this.getAttribute('data-product-id');
  }

  get input() {
    return this.querySelector('input');
  }

  get value() {
    return this.input.value;
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.buttons = Array.from(this.querySelectorAll('button'));
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.input.addEventListener('focus', () => setTimeout(() => this.input.select()));

    this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)), {
      signal: this.abortController.signal,
    });

    this.validateQtyRules();

    this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
    this.quantityBoundriesUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries,
      this.setQuantityBoundries.bind(this)
    );
    this.quantityRulesUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules,
      this.updateQuantityRules.bind(this)
    );
  }

  disconnectedCallback() {
    this.abortController.abort();

    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.quantityBoundriesUnsubscriber) {
      this.quantityBoundriesUnsubscriber();
    }
    if (this.quantityRulesUnsubscriber) {
      this.quantityRulesUnsubscriber();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.getAttribute('data-min')) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.getAttribute('data-min');
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.getAttribute('data-min') === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  onInputChange() {
    if (this.input.value === '') {
      this.input.value = parseInt(this.input.min);
    }
    this.validateQtyRules();
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector('button[name="minus"]');
      if (buttonMinus) buttonMinus.toggleAttribute('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const buttonPlus = this.querySelector('button[name="plus"]');
      if (buttonPlus) buttonPlus.toggleAttribute('disabled', parseInt(value) >= parseInt(this.input.max));
    }
  }

  updateQuantityRules({ data: { sectionId, productId, parsedHTML } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
    const quantityFormUpdated = parsedHTML.getElementById(`QuantityForm-${sectionId}`);
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
    for (let selector of selectors) {
      const current = quantityForm.querySelector(selector);
      const updated = quantityFormUpdated?.querySelector(selector);
      if (!current || !updated) continue;

      if (selector === '.quantity__input') {
        const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }

  setQuantityBoundries({ data: { sectionId, productId } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const data = {
      cartQuantity: this.input.hasAttribute('data-cart-quantity')
        ? parseInt(this.input.getAttribute('data-cart-quantity'))
        : 0,
      min: this.input.hasAttribute('data-min') ? parseInt(this.input.getAttribute('data-min')) : 1,
      max: this.input.hasAttribute('data-max') ? parseInt(this.input.getAttribute('data-max')) : null,
      step: this.input.hasAttribute('step') ? parseInt(this.input.getAttribute('step')) : 1,
    };

    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

    this.input.min = min;

    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute('max');
    }
    this.input.value = min;

    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate, undefined);
  }
}
customElements.define('quantity-input', QuantityInput);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.input = this.querySelector('input');
    this.buttons = Array.from(this.querySelectorAll('button'));
    this.changeEvent = new Event('change', { bubbles: true });

    this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      this.input.quantity = this.input.quantity + 1;
    } else {
      this.input.quantity = this.input.quantity - 1;
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-selector', QuantitySelector);

const onYouTubeApiLoaded = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
class VideoElement extends HTMLElement {
  constructor() {
    super();

    if (this.posterElement) {
      this.posterElement.addEventListener('click', this.handlePosterClick.bind(this));
    }

    if (this.autoplay) {
      FoxTheme.Motion.inView(this, () => {
        if (!this.paused) {
          this.play();
        }

        return () => {
          this.pause();
        };
      });
    }
  }

  get posterElement() {
    return this.querySelector('[id^="DeferredPoster-"]');
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null;
  }

  get autoplay() {
    return this.hasAttribute('autoplay');
  }

  get playing() {
    return this.hasAttribute('playing');
  }

  get player() {
    return (this.playerProxy =
      this.playerProxy ||
      new Proxy(this.initializePlayer(), {
        get: (target, prop) => {
          return async () => {
            target = await target;
            this.handlePlayerAction(target, prop);
          };
        },
      }));
  }

  static get observedAttributes() {
    return ['playing'];
  }

  handlePosterClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
  }

  play() {
    if (!this.playing) {
      this.player.play();
    }
  }

  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        return this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
      }

      if (newValue === null) {
        return this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
      }
    }
  }

  initializePlayer() {
    if (this.hasAttribute('source')) {
      this.setAttribute('loaded', '');
      this.closest('.media')?.classList.remove('loading');

      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1023px)').matches;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        if (this.getAttribute('source') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubeApiLoaded;
          const player = new YT.Player(this.querySelector('iframe'), {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                }
              },
            },
          });
        }
        if (this.getAttribute('source') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player(this.querySelector('iframe'));
          if (muteVideo) {
            player.setMuted(true);
          }
          player.on('play', () => {
            this.setAttribute('playing', '');
          });
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => this.removeAttribute('playing'));
          resolve(player);
        }
      });
    } else {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', '');
      this.closest('.media')?.classList.remove('loading');

      const player = this.querySelector('video');
      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) {
          this.removeAttribute('playing');
        }
      });
      return player;
    }
  }

  handlePlayerAction(target, prop) {
    if (this.getAttribute('source') === 'youtube') {
      prop === 'play' ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === 'play' && !this.hasAttribute('source')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
            const replacementImageSrc = target.previousElementSibling?.currentSrc;
            if (replacementImageSrc) {
              target.poster = replacementImageSrc;
            }
          }
        });
      } else {
        target[prop]();
      }
    }
  }
}
customElements.define('video-element', VideoElement);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure-list'),
    };

    this.elements.panel.removeAttribute('hidden');
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

    this.handleDropdownPos();
  }

  handleDropdownPos() {
    const offsetButton = this.elements.button.getBoundingClientRect().right;
    if (window.innerWidth - offsetButton < 220) {
      this.elements.button.nextElementSibling &&
        this.elements.button.nextElementSibling.classList.add('disclosure-list__right');
    }
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.removeAttribute('open');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.toggleAttribute('open');
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      (event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON') ||
      (event.relatedTarget && !event.relatedTarget.classList.contains('disclosure-list__option'));
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel(shouldClose);
    }
  }
}
customElements.define('localization-form', LocalizationForm);

class GridList extends HTMLElement {
  constructor() {
    super();

    if (FoxTheme.config.motionReduced || this.hasAttribute('motion-reduced')) return;

    this.hideGridItems();
    FoxTheme.Motion.inView(this, this.showGridItems.bind(this), { margin: '0px 0px -50px 0px' });
  }

  get gridItems() {
    return this.querySelectorAll('.f-column');
  }

  get visibleGridItems() {
    return this.querySelectorAll('.f-column:not([style])');
  }

  hideGridItems() {
    FoxTheme.Motion.animate(
      this.gridItems,
      { transform: 'translateY(3.5rem)', opacity: 0.01, visibility: 'hidden' },
      { duration: 0 }
    );
  }

  showGridItems() {
    FoxTheme.Motion.animate(
      this.gridItems,
      { transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0.01, 1], visibility: ['hidden', 'visible'] },
      {
        duration: 0.5,
        delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }

  reShowVisibleGridItems() {
    FoxTheme.Motion.animate(
      this.visibleGridItems,
      { transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0.01, 1], visibility: ['hidden', 'visible'] },
      { duration: 0.5, delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1), easing: [0, 0, 0.3, 1] }
    );
  }
}
customElements.define('grid-list', GridList);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcementItemsWrapper = this.querySelector('.swiper-wrapper');

    FoxTheme.Motion.inView(this, this.initializeCarousel.bind(this), { margin: '200px 0px 200px 0px' });
  }

  getNextSlideButton() {
    return this.querySelector('.swiper-button-next');
  }

  getPrevSlideButton() {
    return this.querySelector('.swiper-button-prev');
  }

  get getSlideItems() {
    return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.announcementItemsWrapper.children));
  }

  isAutoplayEnabled() {
    return this.hasAttribute('autoplay');
  }

  getAutoplaySpeed() {
    return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
  }

  initializeCarousel() {
    if (this.getSlideItems.length > 1) {
      this.carousel = new FoxTheme.Carousel(
        this,
        {
          navigation: {
            nextEl: this.getNextSlideButton(),
            prevEl: this.getPrevSlideButton(),
          },
          loop: true,
          autoplay: this.isAutoplayEnabled() ? { delay: this.getAutoplaySpeed(), pauseOnMouseEnter: true } : false,
        },
        [FoxTheme.Swiper.Autoplay]
      );
      this.carousel && this.carousel.init();

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          this.carousel.slider.slideToLoop(this.getSlideItems.indexOf(event.target));
        });
      }
    }
  }
}
customElements.define('announcement-bar', AnnouncementBar);

class SelectElement extends HTMLElement {
  constructor() {
    super();

    FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });

    this.select = this.querySelector('select');

    this.select && this.select.addEventListener('change', this.handleSelectChange.bind(this));
  }

  init() {
    const style = window.getComputedStyle(this);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement('span');
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = 'hidden';
    text.style.position = 'absolute';
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty('--width', `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define('select-element', SelectElement);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    if (FoxTheme.config.hasLocalStorage) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = 'hypertheme:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

      if (items.includes(productId)) {
        items.splice(items.indexOf(productId), 1);
      }

      items.unshift(productId);

      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

class MotionElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (FoxTheme.config.motionReduced) return;
    this.preInitialize();
    FoxTheme.Motion.inView(
      this,
      async () => {
        if (!this.isInstant && this.mediaElements) await FoxTheme.utils.imageReady(this.mediaElements);
        this.initialize();
      },
      { margin: '0px 0px -80px 0px' }
    );
  }

  get isHold() {
    return this.hasAttribute('hold');
  }

  get isInstant() {
    return this.hasAttribute('data-instantly');
  }

  get mediaElements() {
    return Array.from(this.querySelectorAll('img, iframe, svg'));
  }

  get animationType() {
    return this.dataset.motion || 'fade-up';
  }

  get animationDelay() {
    return parseInt(this.dataset.motionDelay || 0) / 1000;
  }

  preInitialize() {
    if (this.isHold) return;
    switch (this.animationType) {
      case 'fade-in':
        this.style.visibility = 'hidden';
        FoxTheme.Motion.animate(this, { opacity: 0.01 }, { duration: 0 });
        break;

      case 'fade-up':
        this.style.visibility = 'hidden';
        FoxTheme.Motion.animate(this, { transform: 'translateY(2.5rem)', opacity: 0.01 }, { duration: 0 });
        break;

      case 'zoom-in':
        FoxTheme.Motion.animate(this, { transform: 'scale(0.8)' }, { duration: 0 });
        break;
      case 'zoom-in-lg':
        FoxTheme.Motion.animate(this, { transform: 'scale(0)' }, { duration: 0 });
        break;

      case 'zoom-out':
        FoxTheme.Motion.animate(this, { transform: 'scale(1.08)' }, { duration: 0 });
        break;

      case 'zoom-out-sm':
        FoxTheme.Motion.animate(this, { transform: 'scale(1.03)' }, { duration: 0 });
        break;
    }
  }

  async initialize() {
    if (this.isHold) return;

    switch (this.animationType) {
      case 'fade-in':
        this.style.visibility = 'visible';
        await FoxTheme.Motion.animate(
          this,
          { opacity: 1 },
          { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'fade-up':
        this.style.visibility = 'visible';
        await FoxTheme.Motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'zoom-in':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.3, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'zoom-in-lg':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'zoom-out':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;

      case 'zoom-out-sm':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
        ).finished;
        break;
    }
  }

  async resetAnimation(duration) {
    switch (this.animationType) {
      case 'fade-in':
        await FoxTheme.Motion.animate(
          this,
          { opacity: 0 },
          {
            duration: duration ? duration : 1.5,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        ).finished;
        break;

      case 'fade-up':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'translateY(2.5rem)', opacity: 0 },
          {
            duration: duration ? duration : 0.5,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        ).finished;
        break;

      case 'zoom-in':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        ).finished;
        break;

      case 'zoom-in-lg':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        ).finished;
        break;

      case 'zoom-out':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0.16, 1, 0.3, 1],
          }
        ).finished;
        break;

      case 'zoom-out-sm':
        await FoxTheme.Motion.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0.16, 1, 0.3, 1],
          }
        ).finished;
        break;
    }
  }

  refreshAnimation() {
    this.removeAttribute('hold');
    this.preInitialize();
    setTimeout(() => {
      this.initialize();
    }, 50); // Delay a bit to make animation re init properly.
  }
}
customElements.define('motion-element', MotionElement);

class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      tabHeader: '[role="tablist"]',
      tabPanels: ['[role="tabpanel"]'],
      tabNavs: ['[role="tab"]'],
      tabSelect: 'tab-selector',
      tabNav: '.tabs__nav-js',
    };
    this.domNodes = FoxTheme.utils.queryDomNodes(this.selectors, this);

    this.selectedIndex = 0;
    this.selectedTab = this.domNodes.tabPanels[this.selectedIndex];
    this.scrollToActiveTab = this.dataset.scrollToActiveTab === 'true';
    this.scrollOffset = 20;
    this.headerEl = document.querySelector('.header-section header[is="sticky-header"]');

    this.init();
    this.setActiveTab(0);

    this.tabChange = new CustomEvent('tabChange', {
      bubbles: true,
      detail: { selectedTab: this.selectedTab },
    });
  }

  connectedCallback() {
    this.setActiveTab(0);
  }

  init = () => {
    this.buttons.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });
    this.domNodes.tabHeader && this.domNodes.tabHeader.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.setAccessible();
  };

  static get observedAttributes() {
    return ['data-selected'];
  }

  get buttons() {
    return (this._buttons = this._buttons || Array.from(this.domNodes.tabNavs));
  }

  getHeaderHeight() {
    let headerHeight = 0;

    if (this.headerEl) {
      const height = Math.round(this.headerEl.offsetHeight);
      if (this.headerEl.isAlwaysSticky) {
        headerHeight = height;
      } else {
        const isSticky = document.body.classList.contains(this.headerEl.classes.pinned);

        if (window.scrollY > this.offsetTop - this.scrollOffset) {
          headerHeight = height;
        }

        if (isSticky && window.scrollY >= this.offsetTop - this.scrollOffset - height) {
          headerHeight = height;
        }
      }
    }

    return headerHeight;
  }

  scrollToTop() {
    let offsetTop = this.offsetTop - this.scrollOffset - this.getHeaderHeight();
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }

  onTabClick(evt) {
    evt.preventDefault();
    const currentTab = evt.currentTarget;
    const index = currentTab ? Number(currentTab.dataset.index) : 0;
    this.setActiveTab(index);

    if (this.scrollToActiveTab) {
      this.scrollToTop();
    }
  }

  setActiveTab = (tabIndex) => {
    const { tabNavs, tabPanels, tabSelect } = this.domNodes;
    if (tabIndex !== -1) {
      const newHeader = tabNavs && tabNavs[tabIndex];
      const newTab = tabPanels && tabPanels[tabIndex];
      this.setAttribute('data-selected', tabIndex);

      tabNavs.forEach((nav) => nav.setAttribute('aria-selected', false));

      newHeader && newHeader.setAttribute('aria-selected', true);

      this.selectedIndex = tabIndex;
      this.selectedTab = newTab;

      this.dispatchEvent(
        new CustomEvent('tabChange', {
          bubbles: true,
          detail: { selectedIndex: tabIndex, selectedTab: newTab },
        })
      );

      if (tabSelect) {
        tabSelect.querySelector('select').value = tabIndex;
      }
    }
  };

  setAccessible() {
    const { tabNavs, tabPanels } = this.domNodes;
    tabNavs.forEach((tab, index) => {
      if (tab.id) tabPanels[index].setAttribute('aria-labelledby', tab.id);
      tab.setAttribute('aria-selected', index === 0);
      tab.setAttribute('data-index', index);
      if (index !== 0) {
        // tab.setAttribute('tabindex', -1);
      }
    });
    tabPanels.forEach((panel, index) => {
      if (panel.id) tabNavs[index].setAttribute('aria-controls', panel.id);
      panel.setAttribute('tabindex', 0);
    });
  }

  handleKeyDown(e) {
    const { tabNavs } = this.domNodes;
    if (e.keyCode === 39 || e.keyCode === 37) {
      tabNavs[this.selectedIndex].setAttribute('tabindex', -1);
      if (e.keyCode === 39) {
        this.selectedIndex++;
        // If we're at the end, go to the start.
        if (this.selectedIndex >= tabNavs.length) {
          this.selectedIndex = 0;
        }
        // Move left.
      } else if (e.keyCode === 37) {
        this.selectedIndex--;
        // If we're at the start, move to the end.
        if (this.selectedIndex < 0) {
          this.selectedIndex = tabNavs.length - 1;
        }
      }

      tabNavs[this.selectedIndex].setAttribute('tabindex', 0);
      tabNavs[this.selectedIndex].focus();
    }
  }

  getSelected() {
    return {
      index: this.selectedIndex,
      element: this.selectedTab,
    };
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-selected' && oldValue !== null && oldValue !== newValue) {
      const fromButton = this.buttons[parseInt(oldValue)];
      const toButton = this.buttons[parseInt(newValue)];
      this.transition(
        document.getElementById(fromButton.getAttribute('aria-controls')),
        document.getElementById(toButton.getAttribute('aria-controls'))
      );

      this.scrollToActiveButton(toButton);
    }
  }

  scrollToActiveButton(toButton) {
    const containerGap = 15;
    const scrollRect = toButton.getBoundingClientRect();
    const boxRect = this.domNodes.tabNav.getBoundingClientRect();
    const scrollLeft = this.domNodes.tabNav.scrollLeft;
    const scrollOffset = scrollRect.x + scrollLeft - boxRect.x - containerGap;

    this.domNodes.tabNav.scrollTo({
      left: scrollOffset,
      behavior: 'smooth',
    });
  }

  async transition(fromPanel, toPanel) {
    await FoxTheme.Motion.animate(
      fromPanel,
      { transform: ['translateY(0)', 'translateY(2rem)'], opacity: [1, 0] },
      { duration: 0.3 }
    ).finished;

    fromPanel.hidden = true;
    toPanel.hidden = false;

    FoxTheme.Motion.animate(
      toPanel,
      { transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1] },
      { duration: 0.3 }
    ).finished;

    toPanel.querySelector('grid-list') && toPanel.querySelector('grid-list').showGridItems();
  }
}
customElements.define('tabs-component', TabsComponent);

class TabSelector extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.closest('tabs-component');

    this.querySelector('select').addEventListener('change', (e) => {
      this.tabs.setActiveTab(e.target.value);
    });
  }
}
customElements.define('tab-selector', TabSelector);

class Parallax extends HTMLElement {
  get parallax() {
    return this.dataset.parallax ? parseFloat(this.dataset.parallax) : false;
  }

  get parallaxDirection() {
    return this.dataset.parallaxDirection || 'vertical';
  }

  get parallaxMediaElements() {
    return Array.from(this.querySelectorAll('img, video, iframe, svg, video-element'));
  }

  connectedCallback() {
    if (this.shouldInitializeParallax()) {
      this.setupParallax();
    }
  }

  shouldInitializeParallax() {
    return !FoxTheme.config.motionReduced && this.parallax;
  }

  setupParallax() {
    const parallaxScale = 1 + this.parallax;
    const parallaxTranslate = (this.parallax * 100) / (1 + this.parallax);

    let parallaxTransformProperties = {};

    if (this.parallaxDirection === 'vertical') {
      parallaxTransformProperties = {
        transform: [
          `scale(${parallaxScale}) translateY(0)`,
          `scale(${parallaxScale}) translateY(${parallaxTranslate}%)`,
        ],
        transformOrigin: ['bottom', 'bottom'],
      };
    } else if (this.parallaxDirection === 'horizontal') {
      parallaxTransformProperties = {
        transform: [
          `scale(${parallaxScale}) translateX(0)`,
          `scale(${parallaxScale}) translateX(${parallaxTranslate}%)`,
        ],
        transformOrigin: ['right', 'right'],
      };
    } else {
      parallaxTransformProperties = {
        transform: [`scale(1)`, `scale(${parallaxScale})`],
        transformOrigin: ['center', 'center'],
      };
    }

    FoxTheme.Motion.scroll(
      FoxTheme.Motion.animate(this.parallaxMediaElements, parallaxTransformProperties, { easing: 'linear' }),
      {
        target: this,
        offset: ['start end', 'end start'],
      }
    );
  }
}
customElements.define('parallax-element', Parallax);

class ProductForm extends HTMLFormElement {
  constructor() {
    super();

    this.productIdInput = this.querySelector('[name=id]');
    this.productIdInput.disabled = false;
    this.addEventListener('submit', this.handleFormSubmit);
  }

  get cartDrawerElement() {
    return document.querySelector('cart-drawer');
  }

  get submitButtonElement() {
    return (this._submitButtonElement = this._submitButtonElement || this.querySelector('[type="submit"]'));
  }

  get isHideErrors() {
    return this.dataset.hideErrors === 'true';
  }

  handleFormSubmit = (event) => {
    if (FoxTheme.settings.cartType === 'page') return;

    event.preventDefault();
    if (this.submitButtonElement.getAttribute('aria-disabled') === 'true') return;
    this.lastSubmittedElement = event.submitter || event.currentTarget;

    this.displayFormErrors();

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    this.formData = new FormData(this);
    this.formData.append('sections', sectionsToBundle);
    this.formData.append('sections_url', window.location.pathname);

    config.body = this.formData;

    this.submitButtonElement.setAttribute('aria-disabled', 'true');
    this.submitButtonElement.classList.add('btn--loading');

    this.handleFormSubmission(config);
  };

  displayFormErrors = (errorMessage = false) => {
    if (this.isHideErrors) return;
    
    // Get the appropriate error message (custom or auto)
    const finalErrorMessage = errorMessage !== false ? this.getErrorMessage(errorMessage) : false;
    
    // Check the stock limit display method setting
    const displayMethod = FoxTheme?.settings?.stockLimitDisplayMethod || 'text';
    
    if (displayMethod === 'popup' && finalErrorMessage !== false) {
      // Show popup modal instead of inline error
      const stockErrorModal = document.getElementById('StockErrorModal');
      if (stockErrorModal) {
        stockErrorModal.show(finalErrorMessage);
        return;
      }
    }

    // Default text behavior
    this.formErrorMessage = this.formErrorMessage || this.querySelector('.product-form__error-message');
    if (!this.formErrorMessage) {
      if (finalErrorMessage !== false) {
        alert(finalErrorMessage);
      }
    } else {
      this.formErrorMessage.toggleAttribute('hidden', !finalErrorMessage);
      if (finalErrorMessage !== false) {
        this.formErrorMessage.innerText = finalErrorMessage;
      }
    }
  };

  // Helper function to get the appropriate error message
  getErrorMessage(originalMessage) {
    const messageSource = FoxTheme?.settings?.stockErrorMessageSource || 'auto';
    
    if (messageSource === 'custom') {
      const customMessage = FoxTheme?.settings?.stockErrorCustomMessage;
      return customMessage && customMessage.trim() !== '' ? customMessage : originalMessage;
    }
    
    return originalMessage;
  }

  resetFormState() {
    this.hasError = false;
    this.submitButtonElement.removeAttribute('aria-disabled');
    this.displayFormErrors();
  }

  handleFormSubmission = async (config) => {
    try {
      // Get current cart data to check total before adding
      const currentCartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
      
      // Get the product being added
      const variantId = parseInt(this.formData.get('id'));
      const quantity = parseInt(this.formData.get('quantity') || 1);
      
      // Find the variant price
      let variantPrice = 0;
      
      // Try to get variant data from JSON script tags
      const variantScripts = document.querySelectorAll('script[type="application/json"]');
      let productVariants = null;
      
      for (const script of variantScripts) {
        try {
          const data = JSON.parse(script.textContent);
          if (Array.isArray(data) && data.length > 0 && data[0].id && data[0].price !== undefined) {
            const hasTargetVariant = data.some(variant => variant.id === variantId);
            
            if (hasTargetVariant) {
              productVariants = {};
              data.forEach(variant => {
                productVariants[variant.id] = variant;
              });
              break;
            }
          }
          // Handle single variant object (from {{ product.selected_or_first_available_variant | json }})
          else if (data && typeof data === 'object' && data.id && data.price !== undefined) {
            
            if (data.id === variantId) {
              productVariants = {};
              productVariants[data.id] = data;
              break;
            }
          }
        } catch (e) {
          // Continue to next script
        }
      }
      
      if (productVariants && productVariants[variantId]) {
        variantPrice = productVariants[variantId].price;
      } else if (window.productVariants && window.productVariants[variantId]) {
        variantPrice = window.productVariants[variantId].price;
      } else {
        
        // If we couldn't find the variant in any script, try a more targeted approach
        // Look for the current product's form and its associated variant data
        const productForm = this.closest('product-form') || this;
        const productContainer = productForm.closest('[data-product-id]') || productForm.closest('.product') || productForm.closest('[data-section-type="product"]');
        
        if (productContainer) {
          const productScripts = productContainer.querySelectorAll('script[type="application/json"]');
          for (const script of productScripts) {
            try {
              const data = JSON.parse(script.textContent);
              if (Array.isArray(data) && data.length > 0 && data[0].id && data[0].price !== undefined) {
                const targetVariant = data.find(variant => variant.id === variantId);
                if (targetVariant) {
                  variantPrice = targetVariant.price;
                  break;
                }
              }
            } catch (e) {
              // Continue to next script
            }
          }
        }
        
        if (variantPrice === 0) {
          
          // Look for variant selector options with data-price attributes
          const variantOptions = document.querySelectorAll(`select[name="id"] option[value="${variantId}"], input[name="id"][value="${variantId}"]`);
          for (const option of variantOptions) {
            if (option.hasAttribute('data-price')) {
              variantPrice = parseInt(option.getAttribute('data-price')) || 0;
              break;
            }
          }
          
          // If still no price found, try to fetch from Shopify API as last resort
          if (variantPrice === 0) {
            try {
              // Try multiple API approaches
              let productData = null;
              
              // Method 1: Try current product URL
              const currentPath = window.location.pathname;
              if (currentPath.includes('/products/')) {
                const productHandle = currentPath.split('/products/')[1].split('?')[0];
                const productResponse = await fetch(`/products/${productHandle}.js`);
                if (productResponse.ok) {
                  productData = await productResponse.json();
                }
              }
              
              // Method 2: Try to get product ID from form and use variants API
              if (!productData) {
                const productIdInput = this.querySelector('input[name="product-id"], [data-product-id]');
                if (productIdInput) {
                  const productId = productIdInput.value || productIdInput.dataset.productId;
                  if (productId) {
                    const variantResponse = await fetch(`/products/${productId}.js`);
                    if (variantResponse.ok) {
                      productData = await variantResponse.json();
                    }
                  }
                }
              }
              
              // Method 3: Direct variant API call
              if (!productData) {
                const variantResponse = await fetch(`/variants/${variantId}.js`);
                if (variantResponse.ok) {
                  const variantData = await variantResponse.json();
                  if (variantData && variantData.price !== undefined) {
                    variantPrice = variantData.price;
                  }
                }
              }
              
              // If we got product data, find the variant
              if (productData && !variantPrice) {
                const variant = productData.variants.find(v => v.id === variantId);
                if (variant) {
                  variantPrice = variant.price;
                }
              }
            } catch (error) {
            }
          }
        }
      }
      
      // Calculate new total (current cart total + new item total)
      const currentTotal = currentCartJson.total_price || 0;
      const newItemTotal = variantPrice * quantity;
      const newCartTotal = currentTotal + newItemTotal;
      
      // Check if cart limit is enabled and get the limit amount
      const isCartLimitEnabled = FoxTheme?.settings?.enableCartLimit === true;
      if (!isCartLimitEnabled) {
        // Proceed with normal cart add if cart limit is disabled
        fetch(`${FoxTheme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (parsedState) => {
            const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
            cartJson['sections'] = parsedState['sections'];
            if (parsedState.status) {
              this.handleCartError(parsedState, cartJson);
              return;
            }
            this.updateCartState(cartJson);
            this.dispatchProductAddedEvent(parsedState);
            this.showCartDrawer();
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.submitButtonElement.classList.remove('btn--loading');
            if (!this.hasError) {
              this.submitButtonElement.removeAttribute('aria-disabled');
            }
          });
        return;
      }
      
      // Get cart limit from settings (convert TL to cents)
      const cartLimitTL = FoxTheme?.settings?.cartLimitAmount || 150000;
      const CART_LIMIT = cartLimitTL * 100;
      
      
      if (newCartTotal > CART_LIMIT) {
        // Show error popup
        this.showCartLimitError();
        return;
      }
      
      // Proceed with normal cart add if under limit
    fetch(`${FoxTheme.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then(async (parsedState) => {
        const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
        cartJson['sections'] = parsedState['sections'];
        // ürün sayfasından limitten fazla ekleme yaparken çalışıyor
        if (parsedState.status) {
          this.handleCartError(parsedState, cartJson);
          return;
        }

       
        this.updateCartState(cartJson);
        this.dispatchProductAddedEvent(parsedState);
        this.showCartDrawer();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.submitButtonElement.classList.remove('btn--loading');

        if (!this.hasError) {
          this.submitButtonElement.removeAttribute('aria-disabled');
        }
      });
    } catch (error) {
      this.submitButtonElement.classList.remove('btn--loading');
      this.submitButtonElement.removeAttribute('aria-disabled');
    }
  };

  handleCartError = (parsedState, cartJson) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: this.formData.get('id'),
      errors: parsedState.errors || parsedState.description,
      message: parsedState.message,
    });
   
    this.dispatchProductAddedEvent(parsedState);
    this.showCartDrawer();
    this.displayFormErrors(parsedState.description);
    this.updateCartState(cartJson);
    document.dispatchEvent(
      new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: parsedState.description,
        },
      })
    );
    this.hasError = true;
  };

  updateCartState = (cartJson) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  };

  dispatchProductAddedEvent = (parsedState) => {
    document.dispatchEvent(
      new CustomEvent('product-ajax:added', {
        detail: {
          product: parsedState,
        },
      })
    );
  };

  showCartDrawer = () => {
    const quickViewModal = this.closest('quick-view-modal');
    if (quickViewModal) {
      if (this.cartDrawerElement && !this.cartDrawerElement.open) {
        document.body.addEventListener(
          quickViewModal.events.handleAfterHide,
          () => {
            setTimeout(() => {
              this.cartDrawerElement.show(this.lastSubmittedElement);
            });
          },
          { once: true }
        );
      }

      quickViewModal.hide(true);
    } else {
      this.cartDrawerElement && this.cartDrawerElement.show(this.lastSubmittedElement);
    }
  };

  showCartLimitError = () => {
    // Create or show cart limit error popup
    let popup = document.getElementById('CartLimitErrorPopup');
    
    if (!popup) {
      // Create popup if it doesn't exist
      popup = document.createElement('div');
      popup.id = 'CartLimitErrorPopup';
      popup.className = 'cart-limit-popup fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 hidden';
      popup.innerHTML = `
        <div class="cart-limit-popup-content bg-white rounded-lg p-6 max-w-md mx-4 relative">
          <button class="cart-limit-popup-close absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold" aria-label="Kapat">&times;</button>
          <div class="text-center">
            <h3 class="text-lg font-semibold text-gray-900 mb-4">${FoxTheme?.settings?.cartLimitPopupTitle}</h3>
            <p class="text-gray-600 mb-6">${FoxTheme?.settings?.cartLimitPopupMessage || 'Online mağazamızda satın alma limiti 150.000 TL\'dir. Daha yüksek tutarlı alımlarınız için sizi mağazalarımıza bekleriz.'}</p>
            <button class="cart-limit-popup-ok btn btn--primary w-full"><span class="btn__text">${FoxTheme?.settings?.cartLimitPopupButtonText || 'Tamam'}</span></button>
          </div>
        </div>
      `;
      document.body.appendChild(popup);
      
      // Add event listeners
      const closeBtn = popup.querySelector('.cart-limit-popup-close');
      const okBtn = popup.querySelector('.cart-limit-popup-ok');
      const overlay = popup;
      
      const hidePopup = () => {
        popup.classList.add('hidden');
        document.body.style.overflow = '';
        this.submitButtonElement.classList.remove('btn--loading');
        this.submitButtonElement.removeAttribute('aria-disabled');
      };

      const handleOkClick = () => {
        const buttonLink = FoxTheme?.settings?.cartLimitPopupButtonLink;
        if (buttonLink && buttonLink.trim() !== '') {
          window.location.href = buttonLink;
        } else {
          hidePopup();
        }
      };
      
      closeBtn.addEventListener('click', hidePopup);
      okBtn.addEventListener('click', handleOkClick);
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) hidePopup();
      });
      
      // Close with Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !popup.classList.contains('hidden')) {
          hidePopup();
        }
      });
    }
    
    // Show popup
    popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    
    // Focus on OK button for accessibility
    setTimeout(() => {
      popup.querySelector('.cart-limit-popup-ok')?.focus();
    }, 100);
  };
}
customElements.define('product-form', ProductForm, { extends: 'form' });

class NewsletterForm extends HTMLFormElement {
  constructor() {
    super();

    this.selectors = {
      subscribedMessage: '[id*=Newsletter-error-subscribed]',
      modal: '[id*=NewsletterAlertModal-]',
    };

    this.init();
  }

  /**
   * Show message when user re-subscribe with exists email.
   */
  init() {
    const liveUrl = window.location.href;
    const result = liveUrl.includes('form_type=customer');
    const inputVal = this.querySelector('[id*="NewsletterForm"]').value.length;
    const modalEl = this.querySelector(this.selectors.modal);

    if (result && inputVal != 0) {
      const messageElement = this.querySelector(this.selectors.subscribedMessage);
      messageElement && messageElement.classList.remove('hidden');
      if (!window.isNewsletterModalShow) {
        modalEl && modalEl.show();
        window.isNewsletterModalShow = true;
      }
    }
    
    const alertEl = this.querySelector('.form-message--main');
    if (alertEl) {
      if (!window.isNewsletterModalShow) {
        modalEl && modalEl.show();
        window.isNewsletterModalShow = true;
      }
    }
  }
}
customElements.define('newsletter-form', NewsletterForm, { extends: 'form' });

class ColorSwatch extends HTMLUListElement {
  constructor() {
    super();

    this.selectors = {
      card: '.product-card',
      mainImg: '.product-card__image--main img',
      swatches: '.swatch-item',
      variantImg: '.color-swatch--variant-image',
    };

    this.hoverTracker = null;
  }

  connectedCallback() {
    this.optionNodes = this.querySelectorAll(this.selectors.swatches);
    this.init();
  }

  init() {
    this.abortController = new AbortController();

    this.pcard = this.closest(this.selectors.card);
    this.mainImage = this.pcard.querySelector(this.selectors.mainImg);

    this.optionNodes.forEach((button) => {
      button.addEventListener('mouseenter', this.onMouseEnter.bind(this), {
        signal: this.abortController.signal,
      });
    });
  }

  onMouseEnter(e) {
    const { target } = e;
    const variantImage = target.querySelector(this.selectors.variantImg);

    clearTimeout(this.hoverTracker);
    this.hoverTracker = setTimeout(() => {
      this.selected && this.selected.removeAttribute('aria-selected');
      target.setAttribute('aria-selected', true);
      this.selected = target;

      if (this.mainImage && variantImage) {
        // Check if the image is using lazy loading
        if (this.mainImage.getAttribute('is') === 'image-lazy') {
          // For lazy loaded images, update data attributes instead
          this.mainImage.dataset.src = variantImage.src;
          if (variantImage.srcset) {
            this.mainImage.dataset.srcset = variantImage.srcset;
          }
          // Trigger the lazy loading mechanism
          if (this.mainImage.loadImage) {
            this.mainImage.loadImage();
          }
        } else {
          // For regular images, set src directly
          this.mainImage.src = variantImage.src;
          this.mainImage.srcset = variantImage.srcset;
        }
      }
    }, 50);
  }

  disconnectedCallback() {
    this.abortController.abort();
  }
}
customElements.define('color-swatch', ColorSwatch, { extends: 'ul' });

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();
    if (FoxTheme.config.motionReduced) return;
    this.promotion = this.querySelector('.promotion');
    this.repeatTimes = typeof this.dataset.repeats !== 'undefined' ? Number(this.dataset.repeats) : 10;

    FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
  }
  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < this.repeatTimes; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.appendChild(this.clone);
      }

      // Pause when out of view.
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        { rootMargin: '0px 0px 50px 0px' }
      );

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      content: '.read-more__content',
      button: '.read-more__toggle',
      buttonText: '.button-text',
    };

    this.classes = {
      isDisabled: 'is-disabled',
      isCollapsed: 'is-collapsed',
    };

    this.abortController = new AbortController();

    this.toggleClass = this.dataset.toggleClass;
    this.showText = this.dataset.showText;
    this.hideText = this.dataset.hideText;
    this.buttonEl = this.querySelector(this.selectors.button);
    this.contentEl = this.querySelector(this.selectors.content);

    this.buttonEl.addEventListener('click', this.onClick.bind(this), {
      signal: this.abortController.signal,
    });

    this.init();
  }

  init() {
    this.classList.remove(this.classes.isDisabled);
    this.contentEl.classList.remove(this.toggleClass);
    this.showLess();
  }

  showMore() {
    this.contentEl.classList.remove(this.toggleClass);
    this.classList.remove(this.classes.isCollapsed);
    this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.hideText;
    this.resetHeight();
  }

  showLess() {
    this.contentEl.classList.add(this.toggleClass);
    this.classList.add(this.classes.isCollapsed);
    this.buttonEl.querySelector(this.selectors.buttonText).textContent = this.showText;
    this.setHeight();
  }

  setHeight() {
    const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight);
    const lines = parseInt(window.getComputedStyle(this.contentEl).getPropertyValue('--line-clamp'));
    const maxHeight = lineHeight * lines;
    this.contentEl.style.setProperty('max-height', maxHeight + 'px');
  }

  resetHeight() {
    this.contentEl.style.removeProperty('max-height');
  }

  onClick(evt) {
    if (this.contentEl.classList.contains(this.toggleClass)) {
      this.showMore();
    } else {
      this.showLess();
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
  }
}
customElements.define('read-more', ReadMore);

class CopyToClipboard extends HTMLButtonElement {
  constructor() {
    super();

    this.clickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.clickHandler);
  }

  async onClick() {
    const valueToCopy = this.dataset.copyValue;
    const buttonTextEl = this.querySelector('.btn__text');
    const originalText = buttonTextEl.innerText;

    if (!valueToCopy) {
      console.warn('No copy value provided');
      return;
    }

    try {
      // Try modern clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(valueToCopy);
      } else {
        // Fallback for older browsers or non-secure contexts
        const textArea = document.createElement('textarea');
        textArea.value = valueToCopy;
        textArea.style.position = 'absolute';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      
      // Show feedback
      if (buttonTextEl && this.dataset.copiedText) {
        buttonTextEl.innerText = this.dataset.copiedText;
        
        // Reset text after 2 seconds
        setTimeout(() => {
          buttonTextEl.innerText = originalText;
        }, 2000);
      }
      
    } catch (error) {
      console.error('Failed to copy text: ', error);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);
  }
}

// Make CopyToClipboard available globally for debugging
window.CopyToClipboard = CopyToClipboard;

customElements.define('copy-to-clipboard', CopyToClipboard, { extends: 'button' });

class ScrollProgressBar extends HTMLElement {
  constructor() {
    super();
  }

  get totalWidth() {
    return this.contentContainer.offsetWidth;
  }

  get targetId() {
    return this.getAttribute('target');
  }

  get target() {
    return document.getElementById(this.targetId);
  }

  get targetScrollLeft() {
    return this.target.scrollLeft;
  }

  set targetScrollLeft(value) {
    this.target.scrollLeft = value;
  }

  connectedCallback() {
    // Create media query list
    this.mediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);

    // Create ResizeObserver
    this.resizeObserver = new ResizeObserver(() => {
      if (this.mediaQuery.matches) {
        this.init();
      }
    });

    // Store media query handler
    this.mediaQueryHandler = (event) => {
      if (event.matches) {
        this.init();
      } else {
        this.disable();
      }
    };

    // Add media query change listener
    this.mediaQuery.addEventListener('change', this.mediaQueryHandler);

    // Initial check
    if (!this.mediaQuery.matches) {
      this.disable();
      return;
    }

    this.init();
  }

  init() {
    if (!this.target) {
      console.error('Target element not found');
      return;
    }

    this.contentContainer = this.target.children[0];
    this.progressBar = this.querySelector('.progress-bar');

    const targetStyle = window.getComputedStyle(this.target);
    this.targetPadding = parseFloat(targetStyle.paddingLeft) + parseFloat(targetStyle.paddingRight);

    // Start observing target for size changes
    this.resizeObserver.observe(this.target);

    // Check if content overflows
    const viewportWidth = this.target.clientWidth - this.targetPadding;

    if (this.totalWidth <= viewportWidth) {
      this.disable();
      return;
    }

    // Calculate initial progress
    this.calculateInitialProgress();

    // Add scroll listener
    this.scrollHandler = () => {
      requestAnimationFrame(() => this.updateProgress());
    };
    this.target.addEventListener('scroll', this.scrollHandler);

    // Show progress bar and do initial update
    this.style.display = 'block';
    this.updateProgress();
  }

  disable() {
    // Remove scroll listener if exists
    if (this.scrollHandler && this.target) {
      this.target.removeEventListener('scroll', this.scrollHandler);
    }

    // Hide progress bar
    this.style.display = 'none';

    // Reset progress
    if (this.progressBar) {
      this.progressBar.style.width = '0%';
    }

    // Stop observing target
    if (this.target) {
      this.resizeObserver.unobserve(this.target);
    }
  }

  disconnectedCallback() {
    // Clean up media query listener with stored handler
    this.mediaQuery.removeEventListener('change', this.mediaQueryHandler);
    // Disconnect resize observer
    this.resizeObserver.disconnect();
    this.disable();
  }

  calculateInitialProgress() {
    const viewportWidth = this.target.clientWidth - this.targetPadding;
    this.initialProgress = (viewportWidth / this.totalWidth) * 100;

    this.target.addEventListener('scroll', () => {
      requestAnimationFrame(() => this.updateProgress());
    });
    this.updateProgress();
  }

  updateProgress() {
    const factor = FoxTheme.config.isRTL ? -1 : 1;
    const viewportWidth = this.target.clientWidth - this.targetPadding;
    const scrolled =  factor * this.targetScrollLeft;
    const maxScroll = this.totalWidth - viewportWidth;

    const scrollProgress = (scrolled / maxScroll) * (100 - this.initialProgress);
    const totalProgress = this.initialProgress + scrollProgress;

    const clampedProgress = Math.min(100, Math.max(this.initialProgress, totalProgress));

    this.progressBar.style.width = `${clampedProgress}%`;
  }
}

customElements.define('scroll-progress-bar', ScrollProgressBar);

class MasonryLayout extends HTMLElement {
  constructor() {
    super();
  }

  get gridContainer() {
    return this.querySelector('.f-grid') !== null ? this.querySelector('.f-grid') : this;
  }

  get gridItems() {
    return this.querySelectorAll('.f-column');
  }

  get rowGap() {
    const rowGap = window.getComputedStyle(this.gridContainer).getPropertyValue('--f-row-gap');

    return parseFloat(rowGap.replace('rem', '')) * 10;
  }

  get columnNumber() {
    return window.getComputedStyle(this.gridContainer).getPropertyValue('--f-grid-columns') || 1;
  }

  connectedCallback() {
    this.init();
    // const events = ['matchLaptop','unmatchLaptop','matchTablet','unmatchTablet','matchMobile','unmatchMobile'];
    // events.forEach(event => document.addEventListener(event, this.init.bind(this)));
    window.addEventListener('resize', FoxTheme.utils.debounce(this.init.bind(this), 100), false);
  }

  init() {
    if (FoxTheme.config.mqlMobile) {
      this.disable();
    } else {
      this.calculatePositioning();
    }
  }

  disable() {
    Array.from(this.gridItems).forEach((item) => item.style.removeProperty('--offset-top'));
  }

  calculatePositioning() {
    this.disable();
    if (this.columnNumber <= 1) return;
    Array.from(this.gridItems)
      .slice(this.columnNumber)
      .forEach((col, i) => {
        const prevItem = this.gridItems[i].children[0];
        const currentItem = col.children[0];

        const prevItemPos = prevItem.getBoundingClientRect().bottom;
        const currentItemPos = currentItem.getBoundingClientRect().top;

        const offsetTop = prevItemPos - currentItemPos + this.rowGap;

        col.style.setProperty('--offset-top', `${offsetTop}px`);
      });
  }
}
customElements.define('masonry-layout', MasonryLayout);

if (!customElements.get('show-more')) {
  class ShowMore extends ReadMore {
    constructor() {
      super();
    }

    get buttonWrapper() {
      return this.querySelector('.read-more__btn');
    }

    get originalHeight() {
      return this.contentEl.children[0].offsetHeight;
    }

    get swipeMobile() {
      return this.dataset.swipeMobile === 'true';
    }

    get disableOnMobile() {
      return this.dataset.disableOnMobile === 'true';
    }

    connectedCallback() {
      // const events = ['matchLaptop','unmatchLaptop','matchTablet','unmatchTablet','matchMobile','unmatchMobile'];
      // events.forEach(event => document.addEventListener(event, this.init.bind(this)));
      window.addEventListener('resize', FoxTheme.utils.debounce(this.init.bind(this), 100), false);
    }

    init() {
      this.maxHeight = parseInt(this.dataset.maxHeight);

      if (FoxTheme.config.mqlMobile && this.dataset.maxHeightMobile) {
        this.maxHeight = parseInt(this.dataset.maxHeightMobile);
      }

      this.buttonWrapper.classList.toggle('!hidden', this.originalHeight <= this.maxHeight);

      if (this.disable()) {
        this.showMore();
        return;
      }

      super.init();
    }

    setHeight() {
      this.contentEl.style.setProperty('--max-height', this.maxHeight + 'px');
    }

    resetHeight() {
      this.contentEl.style.removeProperty('--max-height');
    }

    disable() {
      return (
        (FoxTheme.config.mqlMobile && this.disableOnMobile) ||
        this.maxHeight <= 0 ||
        this.originalHeight <= this.maxHeight
      );
    }
  }
  customElements.define('show-more', ShowMore);
}

class HighlightText extends HTMLElement {
  constructor() {
    super();
    FoxTheme.Motion.inView(this, this.init.bind(this));
  }
  init() {
    this.classList.add('animate');
  }
}
customElements.define('highlight-text', HighlightText, { extends: 'em' });

const searchEl = document.querySelector('.header--search');
if (searchEl){
  searchEl.addEventListener('click', function () {
    document.body.classList.toggle('search-open');

    const predictiveSearch = document.querySelectorAll('predictive-search');
    const predictiveSearchWrap = document.querySelectorAll('.header__search--wrap');
    if (predictiveSearch) {
      predictiveSearch.forEach((item)=>{
        item.classList.toggle('predictive-search-open');
      })
    }
    if(predictiveSearchWrap){
      predictiveSearchWrap.forEach((item)=>{
        item.classList.toggle('hidden');
      })
    }
    searchEl.classList.add('hidden');
    setTimeout(() => {
      const searchInput = document.querySelector('.search__input.form-control');
      if (searchInput) {
        searchInput.focus();
      }
    }, 100);
  });
}

const closeMobileSearch = document.querySelector('.mobile-close-search');
if(closeMobileSearch){
  closeMobileSearch.addEventListener('click', ()=>{
    document.body.classList.toggle('search-open');

    const predictiveSearch = document.querySelectorAll('predictive-search');
    const predictiveSearchWrap = document.querySelectorAll('.header__search--wrap');
    if (predictiveSearch) {
      predictiveSearch.forEach((item)=>{
        item.classList.toggle('predictive-search-open');
      })
    }
    if(predictiveSearchWrap){
      predictiveSearchWrap.forEach((item)=>{
        item.classList.toggle('hidden');
      })
    }
    if(searchEl){
      searchEl.classList.remove('hidden')
    }
  })
}
